// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:03:34.758Z
// Property: The Union at Eastgate (ID: 6767906449167373)
// Collections: 21 amenities, 35 floorplans (live), 32 photos, 37 POIs, 1 reviews, 1 virtual tours, 6 office hours, 5 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167373",
  "property_external_id": "5165068",
  "property_zillow_url": "https://www.zillow.com/apartments/cincinnati-oh/the-union/CkBRtc/",
  "property_apartments_url": "https://www.apartments.com/the-union-cincinnati-oh/b28zge8/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Union+at+Eastgate/data=!4m2!3m1!1s0x0:0xc352b7d7e26f5575?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "58525255282",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5165068",
  "property_status": null,
  "property_slug": "the-union-at-eastgate",
  "property_name": "The Union at Eastgate",
  "property_website_url": "https://www.unioneastgate.com/",
  "property_domain": "https://www.unioneastgate.com/",
  "property_address": "4427 Aicholtz Rd",
  "property_full_address": "4427 Aicholtz Rd, Cincinnati, OH 45245",
  "property_address_1": "4427 Aicholtz Rd",
  "property_address_2": null,
  "property_address_city": "Cincinnati",
  "property_address_state": "OH",
  "property_address_zip_full": "45245-1527",
  "property_address_zip": "45245",
  "property_address_country": "US",
  "property_address_county": "Clermont County",
  "property_neighborhood_address": "Outer Clermont County",
  "property_address_latitude": "39.0955424",
  "property_address_longitude": "-84.2823098",
  "property_email": "tum@dietzpropertygroup.com",
  "property_phone": "(513) 285-0151",
  "property_call_tracking_phone": "513-960-4155",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At The Union at Eastgate, each stylish studio, one, and two-bedroom apartment is designed for modern living, featuring energy-efficient kitchens and walk-in closets. Enjoy unparalleled amenities like a luxury heated saltwater pool, pet spa, and co-working spaces—all just minutes from downtown Cincinnati. Make your move today!",
  "property_long_description": "**Discover Comfort and Convenience at The Union at Eastgate in Cincinnati, OH!**\n\nWelcome to The Union at Eastgate, where modern living meets unparalleled convenience in the heart of Cincinnati. Our diverse floor plans include spacious studios, one-bedroom, and two-bedroom apartments, each designed with your lifestyle in mind. Enjoy stunning quartz countertops, stainless steel appliances, and luxurious finishes including wood-inspired plank flooring and walk-in closets that maximize your living space.\n\nOur community offers a wealth of amenities that cater to every need. Experience the comfort of controlled access living with a dedicated property manager on-site, ensuring a worry-free environment. Embrace a pet-friendly atmosphere with our dedicated pet play area, spa, and grooming salon. For your convenience, we provide dry cleaning services, package delivery, and door-to-door trash pickup. \n\nStay active and social with our state-of-the-art fitness center, heated saltwater pool, and planned social activities. Enjoy relaxing afternoons at the outdoor fire pit lounges or take advantage of our clubhouse with a café and sports entertainment lounge. With business center access and conference rooms, you can easily balance work and leisure. \n\nLocation is everything, and The Union at Eastgate doesn’t disappoint. With easy access to I-71 and I-275, you're just minutes away from downtown Cincinnati's vibrant lifestyle. \n\nJoin a smoke-free community designed for sustainability, featuring electric car charging stations and community-wide Wi-Fi. \n\nFind your new home today—browse our availability or schedule a tour to visit The Union at Eastgate! Your ideal lifestyle is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019dd0c5-dc69-709d-9b08-ec65adb5bda6.webp",
  "property_featured_image_media": {
    "alt_text": "Modern lounge area with a bar, seating, and a pool table.",
    "public_id": "019dd0c5-dc69-709d-9b08-ec65adb5bda6",
    "storage_key": "property/6767906449167373/019dd0c5-dc69-709d-9b08-ec65adb5bda6.webp",
    "width": 1272,
    "height": 993
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "190",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": "33",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.47368421052632",
  "property_admin_fee": "150",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "We are a pet friendly community. We proudly accept up to 2 pets per apartment home. There is a non‑refundable pet fee of $200 per pet and a monthly pet rent of $35 per pet. Breed restrictions apply.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dogs\nMax Number of Pets: 2\nPet monthly rent max: $35\nPet policy fee max: $200\nPet policy: We are a pet friendly community. We proudly accept up to 2 pets per apartment home. There is a non-refundable pet fee of $200 per pet and a monthly pet rent of $35 per pet. Please contact our Leasing Office for our full pet policy. Breed restrictions apply.",
  "property_online_leasing_url": "https://9011061.onlineleasing.realpage.com/#k=10684",
  "property_resident_portal_url": "https://tumtheunion.loftliving.com/login",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d352-73be-824e-b07366efb90a.webp",
  "property_primary_logo_media": {
    "alt_text": "The Union logo",
    "public_id": "019d63c5-d352-73be-824e-b07366efb90a",
    "storage_key": "property/6767906449167373/019d63c5-d352-73be-824e-b07366efb90a.webp",
    "width": 400,
    "height": 130
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-2c0a-71b0-adce-58dc76ffd79d.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d63c6-2c0a-71b0-adce-58dc76ffd79d",
    "storage_key": "property/6767906449167373/019d63c6-2c0a-71b0-adce-58dc76ffd79d.webp",
    "width": 360,
    "height": 117
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1dc5-7219-bdb3-fd0b4b47749c.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d63c6-1dc5-7219-bdb3-fd0b4b47749c",
    "storage_key": "property/6767906449167373/019d63c6-1dc5-7219-bdb3-fd0b4b47749c.webp",
    "width": 360,
    "height": 117
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#0E465C",
  "property_secondary_color": "#B26726",
  "property_font_color": "#000000",
  "property_color_4": "#ECE9E7",
  "property_color_3": "#228198",
  "property_color_5": "#ffffff",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "396 - 1168",
  "property_sqft_min": "396",
  "property_sqft_max": "1168",
  "property_price_range": "2093",
  "property_price_min": null,
  "property_price_max": "2093",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/TheUnionLuxuryApts",
  "property_instagram_url": "https://www.instagram.com/theunioncincinnati/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJuxsW4R-pQYgRdVVv4te3UsM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Eastgate%2C+Cincinnati%2C+OH",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Union at Eastgate",
  "property_home_romance_title": "Embrace Joyful Living in Your Perfect Apartment Community",
  "property_home_amenities_blurb": "Welcome to The Union at Eastgate, where modern living meets unmatched convenience in Cincinnati. Choose from spacious studio, one, or two-bedroom layouts, all featuring gourmet kitchens and luxurious amenities. Enjoy our heated saltwater pool, pet-friendly areas, and vibrant social activities that foster community spirit. Your exceptional lifestyle awaits!",
  "property_home_floorplans_blurb": "Welcome to The Union at Eastgate in Cincinnati, OH, where modern living meets comfort. From cozy studios to spacious two-bedroom layouts, each floor plan is designed with your lifestyle in mind. Browse our available apartment homes today and find the perfect space to call your own!",
  "property_home_gallery_blurb": "Welcome to The Union at Eastgate, where contemporary living meets comfort in vibrant Cincinnati, OH. Choose from spacious studios to luxurious two-bedroom apartments, all featuring stylish amenities like a heated saltwater pool, fitness center, and pet spa. Enjoy planning your next social event at our inviting clubhouse—your urban retreat awaits!",
  "property_home_neighborhood_blurb": "Nestled in vibrant Cincinnati, The Union at Eastgate blends comfort and convenience. Enjoy easy access to top-notch schools, shopping at EastGate Mall, and parks like Ivy Pointe for outdoor adventures. With diverse studio, one-bedroom, and two-bedroom options, your ideal home is waiting just moments away from local gems.",
  "property_home_reviews_blurb": "At The Union at Eastgate, our residents rave about our exceptional team. One happy family shares, “Skylar is one of the kindest people you will meet,” showcasing the warmth and dedication we bring to your home in Cincinnati, OH. Experience the difference for yourself—see what our residents have to say!",
  "property_neighborhood_blurb": "At The Union at Eastgate, vibrant city living meets suburban charm. Nestled in Cincinnati, our community offers easy access to nature trails, educational institutions like UC Clermont College, and leisure spots including AMC Anderson Towne Center and Kings Island. Embrace a lifestyle filled with convenience and adventure just outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Union at Eastgate in Cincinnati, enjoy a lifestyle enriched by modern comforts and unique amenities. From our pet-friendly parks to a luxurious heated saltwater pool, relaxation and convenience await. Whether working from our business center or unwinding in our sunlit lounge, discover your perfect home today.",
  "property_applynow_blurb": "At The Union at Eastgate in Cincinnati, OH, every detail enhances your living experience. Choose from stylish studio, one, or two-bedroom floor plans while enjoying amenities like a heated saltwater pool, fitness center, and pet-friendly spaces. Ready to find your new home? Secure your lease online today!",
  "property_contactus_blurb": "At The Union at Eastgate in Cincinnati, OH, we offer a variety of thoughtfully designed floor plans, including cozy studios and spacious one and two-bedroom apartments. Every layout is crafted for modern living. Have questions? Our dedicated leasing team is ready to assist you today!",
  "property_faqs_blurb": "At The Union at Eastgate in Cincinnati, OH, we offer thoughtfully designed studio, one-bedroom, and two-bedroom floor plans tailored to your lifestyle. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community and living experience. Uncover the answers you need today!",
  "property_floorplans_blurb": "At The Union at Eastgate in Cincinnati, OH, diverse living options await! Choose from stylish studios, spacious one-bedroom, or inviting two-bedroom layouts designed to fit your lifestyle. Each floor plan boasts modern amenities and a welcoming atmosphere. Browse our available apartment homes and find your ideal space today!",
  "property_gallery_blurb": "At The Union at Eastgate, your perfect home awaits in vibrant Cincinnati! Choose from stylish studio, one, or two-bedroom floor plans, all featuring modern finishes like quartz countertops and stainless steel appliances. With amenities like a heated saltwater pool, fitness center, and pet spa, picture yourself living your best life here!",
  "property_interactivemap_blurb": "At The Union at Eastgate in Cincinnati, our modern studio, one, and two-bedroom apartments boast gourmet kitchens, spacious walk-in closets, and luxurious amenities like a heated saltwater pool and a pet spa. Use our interactive community map to find your ideal home within this vibrant, smoke-free oasis!",
  "property_pets_blurb": "At The Union at Eastgate in Cincinnati, furry friends are cherished! With a warm, pet-friendly atmosphere, residents can share their homes with up to two pets. A $200 non-refundable fee and a monthly pet rent of $35 per pet apply. Enjoy a vibrant community where tails wag and happiness thrives!",
  "property_referafriend_blurb": "At The Union at Eastgate in Cincinnati, OH, your perfect home awaits—whether you choose a cozy studio or a spacious two-bedroom. Embrace a vibrant lifestyle and create lasting memories with great friends. Refer a friend today and enjoy the perks of fantastic neighbors in our welcoming community!",
  "property_residentaccess_blurb": "At The Union at Eastgate, Cincinnati's vibrant community, find your perfect fit with our stylish studio, spacious one-bedroom, and inviting two-bedroom floor plans. Enjoy effortless living—access your resident portal to manage rent, request maintenance, and stay connected. Your convenient home experience awaits! ",
  "property_reviews_blurb": "At The Union at Eastgate, residents appreciate the warm community spirit and responsive management. One resident raves, “Skylar is one of the kindest people you will meet,” while praising our exceptional maintenance team. Experience the vibrant life in Cincinnati where dedicated staff makes every moment feel like home. ",
  "property_created_at": "1775495357240",
  "property_scheduletour_blurb": "Experience the vibrant lifestyle at The Union at Eastgate in Cincinnati, OH, where our diverse floor plans—ranging from cozy studios to spacious two-bedroom apartments—cater to all needs. Curious about life here? Schedule a tour and see what our residents love about their community living experience!",
  "property_thankyou_blurb": "Thank you for reaching out to The Union at Eastgate in vibrant Cincinnati, OH! Whether you're drawn to our cozy studio, spacious one-bedroom, or inviting two-bedroom floor plans, we’re excited to help you find your perfect home. A team member will connect with you shortly to assist!",
  "property_virtualtours_blurb": "Step into The Union at Eastgate, where modern living meets comfort in Cincinnati, OH. From cozy studios to spacious two-bedroom layouts, our apartments cater to every lifestyle. Take a virtual tour today and visualize your new home amidst vibrant amenities and a welcoming community!",
  "property_copyright": "2026 All Rights Reserved. The Union at Eastgate",
  "property_seo_title_home": "The Union at Eastgate |  Apartments in Cincinnati, OH",
  "property_seo_description_home": "Unwind at The Union at Eastgate, where modern living meets luxury. Enjoy top-tier amenities, spacious floor plans, and a vibrant community—all in Cincinnati!",
  "property_seo_title_floorplans": "Floor Plans | Cincinnati, OH Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Union at Eastgate in Cincinnati! Choose from stylish studios, cozy one-bedrooms, or spacious two-bedrooms. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Cincinnati, OH Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at The Union at Eastgate! Enjoy luxurious amenities, spacious floor plans, and a vibrant community—elevate your lifestyle today!",
  "property_seo_title_gallery": "Gallery | Apartments in Cincinnati, OH",
  "property_seo_description_gallery": "Experience luxury living at The Union at Eastgate in Cincinnati, featuring spa-like amenities, diverse floor plans, and lively community spaces!",
  "property_seo_title_virtualtours": "Virtual Tours | The Union at Eastgate Apartments",
  "property_seo_description_virtualtours": "Experience vibrant living at The Union at Eastgate in Cincinnati, OH! Take a virtual tour of our stylish studio, one, and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | The Union at Eastgate Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at The Union at Eastgate! Explore studio to two-bedroom apartments with our interactive map and embrace vibrant Cincinnati living.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Cincinnati, OH",
  "property_seo_description_neighborhood": "Uncover the vibrant culture around The Union at Eastgate in Cincinnati, OH. Delight in local favorites, parks, and convenience just steps from home!",
  "property_seo_title_contact": "Contact Us | The Union at Eastgate",
  "property_seo_description_contact": "Connect with The Union at Eastgate in Cincinnati, OH! Have questions about our studio, one, or two-bedroom apartments? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Cincinnati, OH",
  "property_seo_description_faqs": "Find answers to your questions about The Union at Eastgate in Cincinnati. From amenities to floor plans, browse our FAQs for all you need to know!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Cincinnati, OH",
  "property_seo_description_reviews": "See what residents love about The Union at Eastgate in Cincinnati! Enjoy luxury amenities, spacious floor plans, and a vibrant community lifestyle.",
  "property_seo_title_applynow": "Apply Now | Apartments in Cincinnati, OH",
  "property_seo_description_applynow": "Embrace modern living at The Union at Eastgate! With stunning floor plans and premier amenities, your perfect home awaits in Cincinnati. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Union at Eastgate",
  "property_seo_description_residentaccess": "Unlock convenient living at The Union at Eastgate! Manage rent, request maintenance, and stay connected through your dedicated resident portal today!",
  "property_seo_title_referafriend": "Refer A Friend | The Union at Eastgate",
  "property_seo_description_referafriend": "Great friends make great neighbors! Spread the word about The Union at Eastgate in Cincinnati and enjoy exclusive perks when you refer a friend today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Union at Eastgate",
  "property_seo_description_scheduletour": "Experience vibrant living at The Union at Eastgate in Cincinnati, OH. Schedule a tour today and envision your new home amidst top-notch amenities!",
  "property_seo_title_privacy": "Privacy Policy | The Union at Eastgate",
  "property_seo_description_privacy": "At The Union at Eastgate, your privacy matters. Discover how we safeguard your information for a secure living experience. Check our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | The Union at Eastgate",
  "property_seo_description_accessibility": "Experience inclusivity at The Union at Eastgate, Cincinnati. Our commitment to accessibility makes everyone feel at home in a vibrant community!",
  "property_seo_title_sitemap": "Sitemap | The Union at Eastgate",
  "property_seo_description_sitemap": "Uncover a world of possibilities at The Union at Eastgate. Navigate our sitemap for an easy look at our community, amenities, and more in Cincinnati, OH!",
  "property_seo_title_thankyou": "Thank You | The Union at Eastgate",
  "property_seo_description_thankyou": "Thank you for reaching out to The Union at Eastgate! Our team will connect with you soon to help you find your ideal Cincinnati home—stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Cincinnati, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792124724754",
  "amenities": [
    {
      "id": "ec_09a05b74db7af8da1d31bc8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000319",
      "title": "Sports Entertainment Lounge",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f27bc782b7924b117bd65fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000321",
      "title": "Electric Car Charging Stations",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c9f40d784bd357ec497ad9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000326",
      "title": "Minutes from DT Cincinnati",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37d914632dbdb4cf075332b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000697",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Clubhouse",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8678d046931af4b143127447",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000698",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03aea51cf8eb6e6fb9193d5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000702",
      "title": "Flexible Rent Payments",
      "amount": "0.0000",
      "description": "Flexible Rent Payments",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7856b5447f5c2c8da6a47fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000706",
      "title": "Elevator",
      "amount": "0.0000",
      "description": "Elevator",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7f21218c15df15d51404760",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000714",
      "title": "BBQ/Picnic Area",
      "amount": "0.0000",
      "description": "BBQ/Picnic Area",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_843a229d2452ec23ed6a335c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000715",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Pool",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db4b6f1082af73ff7a9c1b56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000716",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Dog Park",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4105681b52c7d9a2fab4bacf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000718",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "Business Center",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_252e8caac45ee64ce3fb55b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000725",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Fire Pit",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_751cfea44b8b1b558aad1692",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000726",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Coffee Bar",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52e8e0f3ea4c4670dd056235",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000728",
      "title": "Bike Storage",
      "amount": "0.0000",
      "description": "Bike Storage",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be7429efcdc06e9c372cf745",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000336",
      "title": "Energy Efficient",
      "amount": "0.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6728ab41a18ff7f862fc3f18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000502",
      "title": "Smart Lock",
      "amount": "25.0000",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95c5b599765cae98038a385e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000666",
      "title": "Stainless Steel Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a5d64292562d0d0d7d37c65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000667",
      "title": "Washer / Dryer",
      "amount": "0.0000",
      "description": "Washer and Dryer Included",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_687d7cb07823f4b7dad0970d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000668",
      "title": "Vinyl Wood Flooring",
      "amount": "0.0000",
      "description": "Wood-Inspired Plank Flooring",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_514fb84211e2c8fe7c4684dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "P000000669",
      "title": "Quartz Kitchen Counters",
      "amount": "0.0000",
      "description": "Quartz Kitchen Countertops",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26a2dc6cb61cc65f60708eab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "realpage",
      "external_id": "S100000209",
      "title": "Large patio/balcony",
      "amount": "10.0000",
      "description": "Large Patio/Balcony (over 100 sq. ft)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ac7d369c-f026-4849-bea2-32d8c3929576",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019dd0c5-dc69-709d-9b08-ec65adb5bda6.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a bar, seating, and a pool table at The Union at Eastgate.",
        "public_id": "019dd0c5-dc69-709d-9b08-ec65adb5bda6",
        "storage_key": "property/6767906449167373/019dd0c5-dc69-709d-9b08-ec65adb5bda6.webp",
        "width": 1272,
        "height": 993
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a full-service bar, comfortable seating areas, and entertainment options like a pool table.",
      "link": "",
      "alt_text": "Modern lounge area with a bar, seating, and a pool table at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75f64ec5-64a8-4ef5-923f-6d7a04efca14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-f924-70ac-8613-7c47fae0b7ea.webp",
      "image_media": {
        "alt_text": "Two women doing yoga in a park at The Union at Eastgate.",
        "public_id": "019d63c5-f924-70ac-8613-7c47fae0b7ea",
        "storage_key": "property/6767906449167373/019d63c5-f924-70ac-8613-7c47fae0b7ea.webp",
        "width": 480,
        "height": 335
      },
      "title": "Lifestyle",
      "description": "Enjoying a moment of peace and wellness with outdoor yoga sessions in the park.",
      "link": "",
      "alt_text": "Two women doing yoga in a park at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80dc60da-8d13-4149-9f78-1c53e7cb4b70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-f927-73e9-9b8d-cb1f85e5fe1a.webp",
      "image_media": {
        "alt_text": "Couple laughing and enjoying a meal together at a restaurant near The Union at Eastgate.",
        "public_id": "019d63c5-f927-73e9-9b8d-cb1f85e5fe1a",
        "storage_key": "property/6767906449167373/019d63c5-f927-73e9-9b8d-cb1f85e5fe1a.webp",
        "width": 300,
        "height": 200
      },
      "title": "Lifestyle",
      "description": "Enjoy a vibrant dining experience. Our community offers fantastic dining options, perfect for a night out with friends or a romantic dinner.",
      "link": "",
      "alt_text": "Couple laughing and enjoying a meal together at a restaurant near The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60819093-2d4f-4ce1-8b2c-5fbff4005760",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-e1b4-762d-b1cb-bf0c110bd43f.webp",
      "image_media": {
        "alt_text": "Exterior rendering of a modern apartment building with balconies and trees at The Union at Eastgate.",
        "public_id": "019d63c5-e1b4-762d-b1cb-bf0c110bd43f",
        "storage_key": "property/6767906449167373/019d63c5-e1b4-762d-b1cb-bf0c110bd43f.webp",
        "width": 2700,
        "height": 1519
      },
      "title": "Community",
      "description": "Modern apartment building exterior with balconies and mature trees. Offers a glimpse into the community's upscale living spaces.",
      "link": "",
      "alt_text": "Exterior rendering of a modern apartment building with balconies and trees at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c14b75b-a869-4c9c-8f68-c2b83e1d483b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-dd14-71f6-a18a-593b34a8b1d5.webp",
      "image_media": {
        "alt_text": "A light gray sofa with decorative pillows and a throw blanket, next to wooden side tables and a bookshelf At The Union at Eastgate",
        "public_id": "019d63c5-dd14-71f6-a18a-593b34a8b1d5",
        "storage_key": "property/6767906449167373/019d63c5-dd14-71f6-a18a-593b34a8b1d5.webp",
        "width": 2700,
        "height": 1801
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sofa, stylish side tables, and a decorative bookshelf, creating a warm and inviting atmosphere.",
      "link": "",
      "alt_text": "A light gray sofa with decorative pillows and a throw blanket, next to wooden side tables and a bookshelf At The Union at Eastgate",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6473550-502d-4f1a-83a1-6b722e14a42f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d4cc-75f8-a621-ab61257fbb1b.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island, seating, and natural light.",
        "public_id": "019d63c5-d4cc-75f8-a621-ab61257fbb1b",
        "storage_key": "property/6767906449167373/019d63c5-d4cc-75f8-a621-ab61257fbb1b.webp",
        "width": 1000,
        "height": 781
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed apartment featuring a spacious, open-concept layout. The gourmet kitchen boasts an oversized island and ample counter space, flowing seamlessly into the comfortable living area.",
      "link": "",
      "alt_text": "Modern kitchen and living area with island, seating, and natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d88b1ff3-b5cf-4f41-a351-20c878bf7182",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d5a0-7555-ad42-9a135aaaf2d0.webp",
      "image_media": {
        "alt_text": "Modern apartment courtyard with a swimming pool, lounge chairs, umbrellas, and seating areas  at The Union at Eastgate.",
        "public_id": "019d63c5-d5a0-7555-ad42-9a135aaaf2d0",
        "storage_key": "property/6767906449167373/019d63c5-d5a0-7555-ad42-9a135aaaf2d0.webp",
        "width": 965,
        "height": 754
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our stunning outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas for relaxation.",
      "link": "",
      "alt_text": "Modern apartment courtyard with a swimming pool, lounge chairs, umbrellas, and seating areas  at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e677d8a-f50d-48cb-8cef-99fd9d7826fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d401-7079-82da-2ac4a979dcd0.webp",
      "image_media": {
        "alt_text": "Decorative potted plants including snake plant, pothos, and cactus  at The Union at Eastgate.",
        "public_id": "019d63c5-d401-7079-82da-2ac4a979dcd0",
        "storage_key": "property/6767906449167373/019d63c5-d401-7079-82da-2ac4a979dcd0.webp",
        "width": 800,
        "height": 800
      },
      "title": "Other",
      "description": "A selection of attractive potted plants, including a snake plant, pothos, and cacti, displayed in decorative pots on a wooden surface, adding a touch of greenery and style.",
      "link": "",
      "alt_text": "Decorative potted plants including snake plant, pothos, and cactus  at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29f7e110-a212-4027-8e5c-2f878387d86c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d401-7079-82da-2cde03387ae1.webp",
      "image_media": {
        "alt_text": "A tabby cat relaxes on a person's lap, with a hand gently resting on the cat's head.",
        "public_id": "019d63c5-d401-7079-82da-2cde03387ae1",
        "storage_key": "property/6767906449167373/019d63c5-d401-7079-82da-2cde03387ae1.webp",
        "width": 689,
        "height": 459
      },
      "title": "Lifestyle",
      "description": "Enjoy the cozy and comfortable atmosphere of your new home, complete with a furry friend to share it with. Pet-friendly living at its finest.",
      "link": "",
      "alt_text": "A tabby cat relaxes on a person's lap, with a hand gently resting on the cat's head.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89f23f03-798b-4956-9e5a-12c845aee0b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d3fa-717f-83ac-49f85b9aac0d.webp",
      "image_media": {
        "alt_text": "Young woman smiling while playing with her Australian Shepherd puppy on the floor  at The Union at Eastgate.",
        "public_id": "019d63c5-d3fa-717f-83ac-49f85b9aac0d",
        "storage_key": "property/6767906449167373/019d63c5-d3fa-717f-83ac-49f85b9aac0d.webp",
        "width": 800,
        "height": 533
      },
      "title": "Lifestyle",
      "description": "Enjoy quality time with your furry friend in your new home. This pet-friendly apartment community welcomes your beloved companions.",
      "link": "",
      "alt_text": "Young woman smiling while playing with her Australian Shepherd puppy on the floor  at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b926060-8ce4-4cbd-ad35-6487ea871dfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d397-74ef-b548-cbde2dee2698.webp",
      "image_media": {
        "alt_text": "Couple laughing by the pool  at The Union at Eastgate.",
        "public_id": "019d63c5-d397-74ef-b548-cbde2dee2698",
        "storage_key": "property/6767906449167373/019d63c5-d397-74ef-b548-cbde2dee2698.webp",
        "width": 226,
        "height": 339
      },
      "title": "Lifestyle",
      "description": "A couple enjoys a day at the pool, laughing and relaxing by the water.",
      "link": "",
      "alt_text": "Couple laughing by the pool  at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f7ecc068-c15a-4b87-813c-79fecadd220f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-510c-75ce-8c07-db5185179a70.webp",
      "image_media": {
        "alt_text": "Apartment at The Union at Eastgate.",
        "public_id": "019ee037-510c-75ce-8c07-db5185179a70",
        "storage_key": "property/6767906449167373/019ee037-510c-75ce-8c07-db5185179a70.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Bright and modern Apartment at The Union at Eastgate.",
      "link": "",
      "alt_text": "Apartment at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_325fbf15-8140-422e-bb34-585d4ec1b00d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-67fe-75bb-95ac-8e62938c452a.webp",
      "image_media": {
        "alt_text": "Close-up of a bed with navy blue and patterned pillows, a bedside lamp, and framed artwork on the wall.",
        "public_id": "019ee037-67fe-75bb-95ac-8e62938c452a",
        "storage_key": "property/6767906449167373/019ee037-67fe-75bb-95ac-8e62938c452a.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed with decorative pillows, a stylish bedside table with a lamp, and a modern piece of art on the wall.",
      "link": "",
      "alt_text": "Close-up of a bed with navy blue and patterned pillows, a bedside lamp, and framed artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_97b0f51d-04fb-4787-bc07-b28a6e10bcea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-75a1-761e-9731-0f3a12e71554.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with white countertop and dark cabinets, view of bedroom through doorway  Apartment at The Union at Eastgate.",
        "public_id": "019ee037-75a1-761e-9731-0f3a12e71554",
        "storage_key": "property/6767906449167373/019ee037-75a1-761e-9731-0f3a12e71554.webp",
        "width": 1363,
        "height": 911
      },
      "title": "Apartment",
      "description": "Bright and modern bathroom featuring a spacious vanity with a white countertop and ample storage. A glimpse into the cozy bedroom is visible through the open doorway.",
      "link": "",
      "alt_text": "Modern bathroom vanity with white countertop and dark cabinets, view of bedroom through doorway  Apartment at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d4a66040-4160-43e1-9f74-b48353889e04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-6f0c-75b8-9e64-58dcca2922f3.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, and a closet. A door leads to a bathroom.",
        "public_id": "019ee037-6f0c-75b8-9e64-58dcca2922f3",
        "storage_key": "property/6767906449167373/019ee037-6f0c-75b8-9e64-58dcca2922f3.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable bed, a bedside table with a lamp, and a spacious closet. Access to the bathroom is conveniently located.",
      "link": "",
      "alt_text": "Bedroom with a bed, nightstand, and a closet. A door leads to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ea698bb-3c82-4f59-a4f2-809ff3bbe623",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-7205-740c-bd3a-ea614f257a97.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white wire shelving, dark vanity, toilet, and bathtub with shower at The Union at Eastgate.",
        "public_id": "019ee037-7205-740c-bd3a-ea614f257a97",
        "storage_key": "property/6767906449167373/019ee037-7205-740c-bd3a-ea614f257a97.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring ample storage with white wire shelving, a modern dark vanity, toilet, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with white wire shelving, dark vanity, toilet, and bathtub with shower at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_28e17d64-af9a-4f84-86b2-2fb99944d4a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-7b8f-76d9-aa50-6694eaab4ddb.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island, white countertops, stainless steel appliances, and ample cabinet space at The Union at Eastgate.",
        "public_id": "019ee037-7b8f-76d9-aa50-6694eaab4ddb",
        "storage_key": "property/6767906449167373/019ee037-7b8f-76d9-aa50-6694eaab4ddb.webp",
        "width": 1167,
        "height": 911
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this open-concept apartment featuring a gourmet kitchen with an island and a spacious living area perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and living area with island, white countertops, stainless steel appliances, and ample cabinet space at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e99366e-e063-4cd9-bb5b-49fe9d60c55e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-7a99-72fa-95cf-12db31c406fb.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, and abstract art At The Union at Eastgate",
        "public_id": "019ee037-7a99-72fa-95cf-12db31c406fb",
        "storage_key": "property/6767906449167373/019ee037-7a99-72fa-95cf-12db31c406fb.webp",
        "width": 1167,
        "height": 911
      },
      "title": "Apartment",
      "description": "Spacious and modern bedroom featuring a comfortable bed, stylish nightstand, and a vibrant abstract painting, creating a relaxing atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a bed, nightstand, and abstract art At The Union at Eastgate",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dbac548f-045c-4d97-a240-4d957fe322fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-6bbe-734c-aac8-07c0da0e5e5f.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with place settings and flowers at The Union at Eastgate.",
        "public_id": "019ee037-6bbe-734c-aac8-07c0da0e5e5f",
        "storage_key": "property/6767906449167373/019ee037-6bbe-734c-aac8-07c0da0e5e5f.webp",
        "width": 1366,
        "height": 911
      },
      "title": "Apartment",
      "description": "Stylish kitchen island with place settings and a floral arrangement, perfect for entertaining in your new apartment.",
      "link": "",
      "alt_text": "Modern kitchen island with place settings and flowers at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6952fb1-fe26-440d-b851-dd3ceb00dc6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-63b6-76f8-90a0-060681c96e0c.webp",
      "image_media": {
        "alt_text": "Modern gray kitchen with stainless steel appliances and white quartz countertops  at The Union at Eastgate.",
        "public_id": "019ee037-63b6-76f8-90a0-060681c96e0c",
        "storage_key": "property/6767906449167373/019ee037-63b6-76f8-90a0-060681c96e0c.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and stylish backsplash. Perfect for home chefs!",
      "link": "",
      "alt_text": "Modern gray kitchen with stainless steel appliances and white quartz countertops  at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df8a90f3-a776-434f-a07d-016ffa119350",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-4ea3-701d-a780-6924edb3f8fa.webp",
      "image_media": {
        "alt_text": "Stylish living room with a gray sectional sofa, blue accent chair, and a wooden media console with a TV  at The Union at Eastgate.",
        "public_id": "019ee037-4ea3-701d-a780-6924edb3f8fa",
        "storage_key": "property/6767906449167373/019ee037-4ea3-701d-a780-6924edb3f8fa.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Relax and unwind in this chic living room, featuring comfortable seating, a modern media console, and ample natural light.",
      "link": "",
      "alt_text": "Stylish living room with a gray sectional sofa, blue accent chair, and a wooden media console with a TV  at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9161da2e-596a-47ab-a534-a1c223fdc985",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-62e4-702c-9090-9e161d6d1f98.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and seating, stainless steel appliances, and subway tile backsplash at The Union at Eastgate.",
        "public_id": "019ee037-62e4-702c-9090-9e161d6d1f98",
        "storage_key": "property/6767906449167373/019ee037-62e4-702c-9090-9e161d6d1f98.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Stunning kitchen featuring a large island with seating, ample cabinet space, and sleek stainless steel appliances. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with island and seating, stainless steel appliances, and subway tile backsplash at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae516f0d-4d09-468a-bf54-d8b8c139d43b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-6892-749f-8f89-b9839937a9e4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with bar stools  at The Union at Eastgate.",
        "public_id": "019ee037-6892-749f-8f89-b9839937a9e4",
        "storage_key": "property/6767906449167373/019ee037-6892-749f-8f89-b9839937a9e4.webp",
        "width": 1366,
        "height": 911
      },
      "title": "Apartment",
      "description": "This modern apartment kitchen features sleek gray cabinetry, stainless steel appliances, and a spacious island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with bar stools  at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f88bb99-49ce-4526-ac04-79a35f10c6aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-6382-77cc-a672-8428bd620a8b.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with island seating, a brown leather sofa, and a blue accent chair At The Union at Eastgate",
        "public_id": "019ee037-6382-77cc-a672-8428bd620a8b",
        "storage_key": "property/6767906449167373/019ee037-6382-77cc-a672-8428bd620a8b.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Experience comfortable and stylish living in this open-concept apartment, featuring a fully equipped kitchen and a spacious living area perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with island seating, a brown leather sofa, and a blue accent chair At The Union at Eastgate",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_14ca2da3-122a-49a6-8e94-1ff61d8a261a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-4c94-7164-a7d9-f10a904eb900.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a glass-enclosed shower and an open closet at The Union at Eastgate.",
        "public_id": "019ee037-4c94-7164-a7d9-f10a904eb900",
        "storage_key": "property/6767906449167373/019ee037-4c94-7164-a7d9-f10a904eb900.webp",
        "width": 1365,
        "height": 911
      },
      "title": "Apartment",
      "description": "Step into this contemporary bathroom featuring a sleek glass-enclosed shower and a convenient open closet space.",
      "link": "",
      "alt_text": "Modern bathroom with a glass-enclosed shower and an open closet at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_16ed6b0b-0e33-490e-ac93-b3b4a213a1d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-4e9a-724d-b91e-d1fedabaec2d.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, navy blue accents, and a dresser.",
        "public_id": "019ee037-4e9a-724d-b91e-d1fedabaec2d",
        "storage_key": "property/6767906449167373/019ee037-4e9a-724d-b91e-d1fedabaec2d.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen bed with navy accents and ample storage with a stylish dresser.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, navy blue accents, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_524a6ddd-8793-45ee-8be1-192aaac394ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-4eab-7049-9d5f-d62139c36e27.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a closet at The Union at Eastgate.",
        "public_id": "019ee037-4eab-7049-9d5f-d62139c36e27",
        "storage_key": "property/6767906449167373/019ee037-4eab-7049-9d5f-d62139c36e27.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry.",
      "link": "",
      "alt_text": "Stackable washer and dryer in a closet at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_088919af-7bfa-44d6-b90a-58ed1122776e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-4cae-7229-b633-473e6545ad17.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island seating, stainless steel appliances, and gray subway tile backsplash at The Union at Eastgate.",
        "public_id": "019ee037-4cae-7229-b633-473e6545ad17",
        "storage_key": "property/6767906449167373/019ee037-4cae-7229-b633-473e6545ad17.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a large island with seating, stainless steel appliances, ample cabinet storage, and a stylish subway tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with island seating, stainless steel appliances, and gray subway tile backsplash at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a37d5921-b06f-4c59-954c-47a0db14b623",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-4cbd-73a8-a3db-e6cd76587bfb.webp",
      "image_media": {
        "alt_text": "Living room with a leather couch, blue armchair, coffee table, and desk at The Union at Eastgate.",
        "public_id": "019ee037-4cbd-73a8-a3db-e6cd76587bfb",
        "storage_key": "property/6767906449167373/019ee037-4cbd-73a8-a3db-e6cd76587bfb.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush leather sofa and a comfortable blue armchair, perfect for relaxation. A stylish coffee table and a functional desk area complete the space.",
      "link": "",
      "alt_text": "Living room with a leather couch, blue armchair, coffee table, and desk at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_538bb9cb-bbba-4fd7-b77e-ac9ad88cb94d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-5101-7018-a4a9-027c89709411.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and built-in desk area at The Union at Eastgate.",
        "public_id": "019ee037-5101-7018-a4a9-027c89709411",
        "storage_key": "property/6767906449167373/019ee037-5101-7018-a4a9-027c89709411.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island, stainless steel appliances, and a convenient built-in desk area for working from home.",
      "link": "",
      "alt_text": "Modern kitchen with island and built-in desk area at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5843c148-9718-4c6a-9ca1-f5b295d8202d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-4e50-70de-a988-96ab64a9c0e2.webp",
      "image_media": {
        "alt_text": "Living room with a leather couch, blue armchair, large rug, TV, and a desk at The Union at Eastgate.",
        "public_id": "019ee037-4e50-70de-a988-96ab64a9c0e2",
        "storage_key": "property/6767906449167373/019ee037-4e50-70de-a988-96ab64a9c0e2.webp",
        "width": 1367,
        "height": 911
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable leather sofa, a plush rug, and a modern entertainment center. Includes a dedicated workspace by the window.",
      "link": "",
      "alt_text": "Living room with a leather couch, blue armchair, large rug, TV, and a desk at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fc0baee4-d3c4-412d-836e-61bd782ad87b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019ee037-4d20-733d-9b84-ea066f4a63f2.webp",
      "image_media": {
        "alt_text": "Desk with office supplies overlooking courtyard and pool at The Union at Eastgate.",
        "public_id": "019ee037-4d20-733d-9b84-ea066f4a63f2",
        "storage_key": "property/6767906449167373/019ee037-4d20-733d-9b84-ea066f4a63f2.webp",
        "width": 1366,
        "height": 911
      },
      "title": "Apartment",
      "description": "Work from home in style with a dedicated desk space offering views of the resort-style pool and courtyard.",
      "link": "",
      "alt_text": "Desk with office supplies overlooking courtyard and pool at The Union at Eastgate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8671f163-3c97-47b3-ba0c-e0c4e7d51dcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "4394 Glen Este-Withamsville Rd, Cincinnati, OH 45245, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food options, including steak, fried chicken, and seafood. They also highlight the friendly and attentive service, and the clean restrooms.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-396e-75ab-8ad2-49c15c8ca8bf.webp",
      "poi_featured_image_media": {
        "alt_text": "Golden Corral restaurant exterior at dusk with neon sign lit.",
        "public_id": "019d63c5-396e-75ab-8ad2-49c15c8ca8bf",
        "storage_key": "property/6767906449167373/019d63c5-396e-75ab-8ad2-49c15c8ca8bf.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/874/golden-corral-glen-este-withamsville-rd?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=874",
      "poi_directions_map_url": "https://maps.google.com/?cid=17289338657885285423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "39.0928968",
      "poi_longitude": "-84.2625723",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-752-0137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d63c6-1179-739e-88d3-4cdc7e3dd1c1",
        "storage_key": "property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6exRFEHQYgRL2yuEOgR8O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_79aebf79-cb1a-46e3-a699-77727f63c15b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Fifty West Brewing Company- Burger Bar",
      "poi_type": "Restaurants",
      "poi_address": "7605 Wooster Pike, Cincinnati, OH 45227, USA",
      "poi_short_description": "Craft brewery & taproom offering various drafts, small bites & events in casual, rustic digs.",
      "poi_long_description": "People say this restaurant serves delicious burgers, shakes, and loaded fries. They also highlight the fun, energetic atmosphere with outdoor spaces, sand volleyball, and pickleball courts, and the friendly, accommodating staff.\n\nSome reviews mention parking can be challenging.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-513a-757b-bbb4-9434c8878581.webp",
      "poi_featured_image_media": {
        "alt_text": "Brewery production line with large stainless steel tanks and conveyor belts.",
        "public_id": "019d63c5-513a-757b-bbb4-9434c8878581",
        "storage_key": "property/6767906449167373/019d63c5-513a-757b-bbb4-9434c8878581.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://fiftywestbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1980328418949706539&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fifty-west-brewing-company--burger-bar",
      "poi_latitude": "39.1392932",
      "poi_longitude": "-84.3551409",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 513-834-8789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d63c6-1179-739e-88d3-4cdc7e3dd1c1",
        "storage_key": "property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-_aI7SrQYgRK7MbbjSKexs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_dde42e2e-e221-40a0-b51b-87211beb0df0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "874 Eastgate N Dr, Cincinnati, OH 45245, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and waffle fries. They also highlight the fast service, friendly staff, and pleasant environment.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-412d-751b-b9a3-bdd5c68427e3.webp",
      "poi_featured_image_media": {
        "alt_text": "Chick-fil-A restaurant exterior with cars in the parking lot and signage.",
        "public_id": "019d63c5-412d-751b-b9a3-bdd5c68427e3",
        "storage_key": "property/6767906449167373/019d63c5-412d-751b-b9a3-bdd5c68427e3.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/oh/eastgate?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8322125666414861949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "39.0966004",
      "poi_longitude": "-84.2656865",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-752-0223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d63c6-1179-739e-88d3-4cdc7e3dd1c1",
        "storage_key": "property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXiYtVQHQYgRfZ7RejMhfnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_be88026a-0e6b-4d52-921e-54282c1ad2e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "375 Rivers Edge Dr, Milford, OH 45150, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves juicy and flavorful steaks, as well as delicious appetizers and sides. They also highlight the attentive and friendly service, and the fun, lively atmosphere.\n\nSome reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-3d92-739a-ab30-c008d1591926.webp",
      "poi_featured_image_media": {
        "alt_text": "Texas Roadhouse restaurant exterior with brick and wood facade, entrance, and signage.",
        "public_id": "019d63c5-3d92-739a-ab30-c008d1591926",
        "storage_key": "property/6767906449167373/019d63c5-3d92-739a-ab30-c008d1591926.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/ohio/milford?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3969114688477194125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "39.1606379",
      "poi_longitude": "-84.2716406",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-831-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d63c6-1179-739e-88d3-4cdc7e3dd1c1",
        "storage_key": "property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0YqYQKCqQYgRjed3p8cgFTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ee6a4ea7-2c2a-4486-b0d9-069c3e4f712c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "826 Eastgate N Dr, Cincinnati, OH 45245, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves fresh and delicious chicken tenders, and the Cane's sauce is a highlight. They highlight the friendly and welcoming staff, and the quick service. They also like the clean atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-3d91-7517-a649-7784b226f0e5.webp",
      "poi_featured_image_media": {
        "alt_text": "Raising Cane's restaurant exterior with outdoor seating and a large sign.",
        "public_id": "019d63c5-3d91-7517-a649-7784b226f0e5",
        "storage_key": "property/6767906449167373/019d63c5-3d91-7517-a649-7784b226f0e5.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/oh/cincinnati/826-eastgate-north-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=15619495459145591646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "39.097784",
      "poi_longitude": "-84.26921089999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-327-2665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d63c6-1179-739e-88d3-4cdc7e3dd1c1",
        "storage_key": "property/6767906449167373/019d63c6-1179-739e-88d3-4cdc7e3dd1c1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYwUawCqQYgRXiszTV2Yw9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_85c50ee2-e425-4433-9a4b-3c8d79b882a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Jungle Jim's International Market Eastgate",
      "poi_type": "Shopping & Retail",
      "poi_address": "4450 Eastgate S Dr, Cincinnati, OH 45245, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this supermarket offers a vast selection of international foods, snacks, spices, sauces, fresh produce, meats, cheeses, and beverages from around the world. They highlight the fun and unique shopping experience, with quirky decor and themed sections, and the fair prices for the quality and specialty items. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-396c-73ec-bd52-25edabd060e1.webp",
      "poi_featured_image_media": {
        "alt_text": "Jungle Jim's International Market with a monorail and parking lot.",
        "public_id": "019d63c5-396c-73ec-bd52-25edabd060e1",
        "storage_key": "property/6767906449167373/019d63c5-396c-73ec-bd52-25edabd060e1.webp",
        "width": 2048,
        "height": 1371
      },
      "poi_business_url": "http://www.junglejims.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12176366739531029726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jungle-jims-international-market-eastgate",
      "poi_latitude": "39.0932973",
      "poi_longitude": "-84.273634",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-674-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11ad-744c-a4c5-14989549239d.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63c6-11ad-744c-a4c5-14989549239d",
        "storage_key": "property/6767906449167373/019d63c6-11ad-744c-a4c5-14989549239d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGxo87_6pQYgR3tygVAkl-6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_b693892e-574a-450a-9f9d-86e60ac0e4de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "520 Ohio Pike, Cincinnati, OH 45255, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and tools. They also highlight the friendly and helpful staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-4c76-74ec-a958-46d2f1ca28f4.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot logo on the building exterior.",
        "public_id": "019d63c5-4c76-74ec-a958-46d2f1ca28f4",
        "storage_key": "property/6767906449167373/019d63c5-4c76-74ec-a958-46d2f1ca28f4.webp",
        "width": 2917,
        "height": 1714
      },
      "poi_business_url": "https://www.homedepot.com/l/Beechmont/OH/Cincinnati/45255/3812?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9794476180080970816&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.0729087",
      "poi_longitude": "-84.3046628",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-688-1654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1182-7088-8a41-e5bcbb57e26c.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d63c6-1182-7088-8a41-e5bcbb57e26c",
        "storage_key": "property/6767906449167373/019d63c6-1182-7088-8a41-e5bcbb57e26c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ02r2aqupQYgRQEzAQjH47Ic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_0b043101-a01f-4f2d-a101-0bc20e3f9d8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Meijer",
      "poi_type": "Shopping & Retail",
      "poi_address": "888 Eastgate N Dr, Cincinnati, OH 45245, USA",
      "poi_short_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_long_description": "People say this supermarket offers a wide variety of groceries, including fresh produce, meat, and seafood, as well as a pharmacy and other departments. They also highlight the helpful staff, good deals, and convenient late hours.\n\nOther reviews mention the pickup service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-3ce0-71fd-92b8-33bc781bd4f7.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of the building entrance with plants displayed outside.",
        "public_id": "019d63c5-3ce0-71fd-92b8-33bc781bd4f7",
        "storage_key": "property/6767906449167373/019d63c5-3ce0-71fd-92b8-33bc781bd4f7.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.meijer.com/shopping/store-locator/148.html?cmpid=LM:Web::::05112021::GoogleGrocery",
      "poi_directions_map_url": "https://maps.google.com/?cid=7555311024026332856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meijer",
      "poi_latitude": "39.0979071",
      "poi_longitude": "-84.2637847",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-943-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11ad-744c-a4c5-14989549239d.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63c6-11ad-744c-a4c5-14989549239d",
        "storage_key": "property/6767906449167373/019d63c6-11ad-744c-a4c5-14989549239d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq_HAn6wAQYgRuK6uuljb2Wg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_a88067f9-68ab-4ddd-a311-7d8b7879ea29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "262 W Main St, Amelia, OH 45102, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh and stocked seafood, and the shelves are organized. They also highlight the kind staff, ample parking, and timely pharmacy service.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-396e-75ab-8ad2-4751f2580601.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Kroger grocery store with pharmacy.",
        "public_id": "019d63c5-396e-75ab-8ad2-4751f2580601",
        "storage_key": "property/6767906449167373/019d63c5-396e-75ab-8ad2-4751f2580601.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/amelia/pierce-township-marketplace/014/00468?cid=loc_01400468_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12179222708940120886&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "39.0359863",
      "poi_longitude": "-84.2330199",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 513-718-2202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11ad-744c-a4c5-14989549239d.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d63c6-11ad-744c-a4c5-14989549239d",
        "storage_key": "property/6767906449167373/019d63c6-11ad-744c-a4c5-14989549239d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ896CL7QHQYgRNiO_hoZKBak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_43b27ec4-7b9d-4788-a465-e4a692e7c547",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "618 Mt Moriah Dr, Cincinnati, OH 45245, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of tools, hardware, and supplies for home improvement projects. They also highlight the helpful staff and the clean, well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-39ad-71ee-b87b-ebbd38fef3a9.webp",
      "poi_featured_image_media": {
        "alt_text": "Lowe's logo on blue brick building",
        "public_id": "019d63c5-39ad-71ee-b87b-ebbd38fef3a9",
        "storage_key": "property/6767906449167373/019d63c5-39ad-71ee-b87b-ebbd38fef3a9.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OH-Cincinnati/1160?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1160-_-na-_-0-_-0&y_source=1_MTE4MzQ4OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11994481452953506456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "39.0679",
      "poi_longitude": "-84.2963",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-753-5094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1182-7088-8a41-e5bcbb57e26c.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d63c6-1182-7088-8a41-e5bcbb57e26c",
        "storage_key": "property/6767906449167373/019d63c6-1182-7088-8a41-e5bcbb57e26c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSXMF-cepQYgRmBJO_FT1dKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_1ac23e44-e1f9-41e5-925c-c20fba3c3c1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "UC Clermont College",
      "poi_type": "Education",
      "poi_address": "4200 Clermont College Dr, Batavia, OH 45103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-64af-72b8-954c-b6169f7af8c9.webp",
      "poi_featured_image_media": {
        "alt_text": "University of Cincinnati Clermont College monument sign with building and grounds.",
        "public_id": "019d63c5-64af-72b8-954c-b6169f7af8c9",
        "storage_key": "property/6767906449167373/019d63c5-64af-72b8-954c-b6169f7af8c9.webp",
        "width": 2048,
        "height": 1365
      },
      "poi_business_url": "http://www.ucclermont.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11199487859864516124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uc-clermont-college",
      "poi_latitude": "39.0797116",
      "poi_longitude": "-84.1955973",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 513-556-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1183-715b-a2a5-4fbfc8598002.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d63c6-1183-715b-a2a5-4fbfc8598002",
        "storage_key": "property/6767906449167373/019d63c6-1183-715b-a2a5-4fbfc8598002.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbSpACLsGQYgRHDaGAd-SbJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_edf3d544-f046-475e-ae9a-aba422b78b03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Tri State Warbird Museum",
      "poi_type": "Entertainment",
      "poi_address": "4021 Borman Dr, Batavia, OH 45103, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this museum features a collection of well-maintained planes and old cars, with knowledgeable and friendly staff. They also highlight the impressive displays and the opportunity to see planes up close.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-632b-72fd-83a6-57cd95a9c576.webp",
      "poi_featured_image_media": {
        "alt_text": "The Tri-State Warbird Museum logo on a vintage airplane flying in the sky.",
        "public_id": "019d63c5-632b-72fd-83a6-57cd95a9c576",
        "storage_key": "property/6767906449167373/019d63c5-632b-72fd-83a6-57cd95a9c576.webp",
        "width": 2048,
        "height": 1415
      },
      "poi_business_url": "http://www.tri-statewarbirdmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101238609613988860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tri-state-warbird-museum",
      "poi_latitude": "39.07758219999999",
      "poi_longitude": "-84.2130234",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-735-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11b0-7008-9bca-25c2b41099d1.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with the letter M",
        "public_id": "019d63c6-11b0-7008-9bca-25c2b41099d1",
        "storage_key": "property/6767906449167373/019d63c6-11b0-7008-9bca-25c2b41099d1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOQJq6cMGQYgR_KPk1LKFD5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_956ab76d-136a-41fe-a515-214b41abd273",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Parky's Wetland Adventures",
      "poi_type": "Entertainment",
      "poi_address": "Cincinnati, OH 45255, USA",
      "poi_short_description": "Park for children featuring a splash pad and other water play features.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-688e-7689-b3af-c5cf20859c7b.webp",
      "poi_featured_image_media": {
        "alt_text": "Children play in a splash pad with slides and water features on a sunny day.",
        "public_id": "019d63c5-688e-7689-b3af-c5cf20859c7b",
        "storage_key": "property/6767906449167373/019d63c5-688e-7689-b3af-c5cf20859c7b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.greatparks.org/recreation/playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=14228404279819358884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parkys-wetland-adventures",
      "poi_latitude": "39.0380988",
      "poi_longitude": "-84.3268319",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVxtnt-yoQYgRpNJHo05ydcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_ce51bf9f-0dc6-4544-8a5d-d09d5fbf937a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Historic Stonelick Covered Bridge",
      "poi_type": "Entertainment",
      "poi_address": "5221 Stonelick Williams Corner Rd, Batavia, OH 45103, USA",
      "poi_short_description": "Restored 1878 span featuring red-painted timber trusses, cars can drive through.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-7653-72f3-bdbf-7e31c3e6055d.webp",
      "poi_featured_image_media": {
        "alt_text": "Red covered bridge over a small creek surrounded by lush green trees and a blue sky with white clouds.",
        "public_id": "019d63c5-7653-72f3-bdbf-7e31c3e6055d",
        "storage_key": "property/6767906449167373/019d63c5-7653-72f3-bdbf-7e31c3e6055d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3936041634615230180&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "historic-stonelick-covered-bridge",
      "poi_latitude": "39.1313473",
      "poi_longitude": "-84.187114",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7St7n0BQYgR5H5jPAOhnzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_07a1ee2e-e4cc-4e62-8eb2-b4fdd6d7302e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Promont House",
      "poi_type": "Entertainment",
      "poi_address": "906 Main St, Milford, OH 45150, USA",
      "poi_short_description": "Breathtaking 3-story mansion, built c. 1860, for tours & events, plus afternoon tea.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-669d-7568-bc8c-f9a2cfb2a677.webp",
      "poi_featured_image_media": {
        "alt_text": "Victorian-style building exterior with a tower and a wraparound porch.",
        "public_id": "019d63c5-669d-7568-bc8c-f9a2cfb2a677",
        "storage_key": "property/6767906449167373/019d63c5-669d-7568-bc8c-f9a2cfb2a677.webp",
        "width": 2762,
        "height": 3072
      },
      "poi_business_url": "http://www.milfordhistory.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8863283898172324319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "promont-house",
      "poi_latitude": "39.1770845",
      "poi_longitude": "-84.279518",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 513-248-0324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11b0-7008-9bca-25c2b41099d1.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with the letter M",
        "public_id": "019d63c6-11b0-7008-9bca-25c2b41099d1",
        "storage_key": "property/6767906449167373/019d63c6-11b0-7008-9bca-25c2b41099d1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJSz57mK2qQYgR3zkA5r61AHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b25fb530-1882-4a2c-aade-b939ed0ea022",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "West Clermont Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Batavia, OH 45103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-77cb-77ff-b8ac-e8f3252e19ce.webp",
      "poi_featured_image_media": {
        "alt_text": "American football field and stadium with dark, stormy clouds overhead.",
        "public_id": "019d63c5-77cb-77ff-b8ac-e8f3252e19ce",
        "storage_key": "property/6767906449167373/019d63c5-77cb-77ff-b8ac-e8f3252e19ce.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://ohiostadiums.com/stadium.php?id=2464",
      "poi_directions_map_url": "https://maps.google.com/?cid=13481260096912173599&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-clermont-stadium",
      "poi_latitude": "39.0702401",
      "poi_longitude": "-84.24912909999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-118e-758c-81f8-e97fc97c4006.webp",
      "poi_map_icon_media": {
        "alt_text": "Abstract representation of two people sitting at a table.",
        "public_id": "019d63c6-118e-758c-81f8-e97fc97c4006",
        "storage_key": "property/6767906449167373/019d63c6-118e-758c-81f8-e97fc97c4006.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx1EOVlcHQYgRHyoZoaEOF7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ce1f6f72-b527-4272-b339-30511a1f468b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4400 Eastgate Square Dr, Cincinnati, OH 45245, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym is clean and well-maintained, with a spacious layout and a wide variety of equipment, including Smith weight machines. They also highlight the friendly and helpful staff, and the great value for the price.\n\nSome reviews mention the gym can be closed during certain hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-7761-7149-9780-baace8ac6af6.webp",
      "poi_featured_image_media": {
        "alt_text": "A busy gym with people working out on various purple machines.",
        "public_id": "019d63c5-7761-7149-9780-baace8ac6af6",
        "storage_key": "property/6767906449167373/019d63c5-7761-7149-9780-baace8ac6af6.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/cincinnati-eastgate-oh?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12951372138375552800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.0938496",
      "poi_longitude": "-84.2679593",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-843-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo5q0uFUHQYgRIB_ELVeEvLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ae15d0e7-1cb6-4eee-8ddf-4d0cb67c49b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "M.E. Lyons YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8108 Clough Pike, Cincinnati, OH 45244, USA",
      "poi_short_description": "Well-equipped gym with a sauna, clean pools and friendly staff plus fitness classes, such as water aerobics.",
      "poi_long_description": "People say this gym offers a variety of activities, including swimming, sports, and classes, and has a beautiful outdoor pool. They highlight the friendly, welcoming, and community-oriented atmosphere, and the convenient reservation system for lap swimming. They also like the helpful and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-89ce-7339-bd51-0cb0f298a13f.webp",
      "poi_featured_image_media": {
        "alt_text": "Indoor swimming pool with lanes and lounge chairs.",
        "public_id": "019d63c5-89ce-7339-bd51-0cb0f298a13f",
        "storage_key": "property/6767906449167373/019d63c5-89ce-7339-bd51-0cb0f298a13f.webp",
        "width": 3072,
        "height": 2044
      },
      "poi_business_url": "https://myy.org/location/me-lyons-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16585976630580806040&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "me-lyons-ymca",
      "poi_latitude": "39.089621",
      "poi_longitude": "-84.32842",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-474-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW2XwC2apQYgRmAGzht45LeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a92203fd-ce1b-4583-b7a9-482655f3afdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Beechmont Racquet & Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "435 Ohio Pike, Cincinnati, OH 45255, USA",
      "poi_short_description": "Vast fitness center featuring weight rooms, cardio equipment, basketball and racquetball courts and an indoor track, plus a pool and childcare.",
      "poi_long_description": "People say this fitness center offers a wide variety of activities, including racquetball, tennis, a pool, a sauna, and a track, as well as cardio and weight machines. They highlight the spacious layout, the friendly staff, and the well-maintained equipment. They also like the value of the membership, which provides access to all amenities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-8d5e-73e9-98eb-7c055fff1520.webp",
      "poi_featured_image_media": {
        "alt_text": "Person doing a plank exercise in a well-equipped gym with turf flooring.",
        "public_id": "019d63c5-8d5e-73e9-98eb-7c055fff1520",
        "storage_key": "property/6767906449167373/019d63c5-8d5e-73e9-98eb-7c055fff1520.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.beechmontfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17041881243667238466&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beechmont-racquet--fitness",
      "poi_latitude": "39.0703739",
      "poi_longitude": "-84.3111476",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-528-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXy0F6epQYgRQo4tCbPsgOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_f78379aa-a4b5-4056-b187-449552dd1c5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Gymnastics Central",
      "poi_type": "Health and Wellness",
      "poi_address": "3972 Bach Buxton Rd, Amelia, OH 45102, USA",
      "poi_short_description": "Spacious gym and camp offering gymnastics lessons, tumbling classes and more.",
      "poi_long_description": "People say this gymnastics center offers a variety of classes, including gymnastics, ninja warrior, trampoline, tumbling, and cheer. They highlight the clean, well-maintained equipment and spacious facility, as well as the positive and encouraging atmosphere. They also like the knowledgeable and skilled coaches who focus on proper technique and athlete confidence.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-9721-7751-8572-07cba2ef69c4.webp",
      "poi_featured_image_media": {
        "alt_text": "Indoor gymnastics facility with balance beams, mats, and other equipment.",
        "public_id": "019d63c5-9721-7751-8572-07cba2ef69c4",
        "storage_key": "property/6767906449167373/019d63c5-9721-7751-8572-07cba2ef69c4.webp",
        "width": 2447,
        "height": 1011
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7847229520774292317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gymnastics-central",
      "poi_latitude": "39.0633025",
      "poi_longitude": "-84.2440629",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-947-0540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1183-715b-a2a5-4fbfc8598002.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d63c6-1183-715b-a2a5-4fbfc8598002",
        "storage_key": "property/6767906449167373/019d63c6-1183-715b-a2a5-4fbfc8598002.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFZeH_BoEQYgRXeO1OKz15mw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a67450b6-9b49-40af-9110-431b757e71f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Crunch Fitness - Anderson",
      "poi_type": "Health and Wellness",
      "poi_address": "7520 Beechmont Ave, Cincinnati, OH 45255, USA",
      "poi_short_description": "Gym featuring free weights , cardio machines, and group fitness classes along with personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes, including boxing and yoga. They also highlight the friendly and helpful staff, and the clean facilities.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-9c7e-731f-87f4-a7d4f37c7edf.webp",
      "poi_featured_image_media": {
        "alt_text": "Two men lifting weights in a gym.",
        "public_id": "019d63c5-9c7e-731f-87f4-a7d4f37c7edf",
        "storage_key": "property/6767906449167373/019d63c5-9c7e-731f-87f4-a7d4f37c7edf.webp",
        "width": 1710,
        "height": 962
      },
      "poi_business_url": "https://www.crunch.com/locations/anderson",
      "poi_directions_map_url": "https://maps.google.com/?cid=5602801208227463229&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---anderson",
      "poi_latitude": "39.0759873",
      "poi_longitude": "-84.34882669999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 513-233-0348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI45DchGpQYgRPQCHkwMmwU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3f6d4308-d961-4f8e-a7d8-2a4875f0de31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Mercy Health - Anderson HealthPlex",
      "poi_type": "Health and Wellness",
      "poi_address": "7495 State Rd, Cincinnati, OH 45255, USA",
      "poi_short_description": "Gym, pool and health center providing fitness programs and personal trainers, plus a steam room, sauna and hot tub.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-9cee-773b-81e6-f9b8b2992fe8.webp",
      "poi_featured_image_media": {
        "alt_text": "A well-lit physical therapy gym with treadmills, exercise equipment, and therapy balls.",
        "public_id": "019d63c5-9cee-773b-81e6-f9b8b2992fe8",
        "storage_key": "property/6767906449167373/019d63c5-9cee-773b-81e6-f9b8b2992fe8.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://www.mercy.com/locations/fitness-healthplex/cincinnati/mercy-health-anderson-healthplex?utm_source=google?utm_medium=organic&utm_content=local_website_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13255182053548908687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-health---anderson-healthplex",
      "poi_latitude": "39.0810048",
      "poi_longitude": "-84.34987319999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 513-624-1871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8_q67kupQYgRj2DqRtnd87c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c1202661-1d3a-468d-8cae-4a2510c61c9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Ambiance Nail Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "720 Eastgate S Dr, Cincinnati, OH 45245, USA",
      "poi_short_description": "Chains salon doing shellac manicures and pedicures as well as gels and acrylics. Service: Helpful.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-a328-768f-afe7-63c33acb12b1.webp",
      "poi_featured_image_media": {
        "alt_text": "Close-up of a hand with light pink nails and a diamond engagement ring.",
        "public_id": "019d63c5-a328-768f-afe7-63c33acb12b1",
        "storage_key": "property/6767906449167373/019d63c5-a328-768f-afe7-63c33acb12b1.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.ambiancenails.com/ambiance-5-booking",
      "poi_directions_map_url": "https://maps.google.com/?cid=10848702930898614173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ambiance-nail-spa",
      "poi_latitude": "39.0954069",
      "poi_longitude": "-84.272627",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-947-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdcZkp_-pQYgRnXfzNdZVjpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_32291519-f5ca-4f32-a685-eb2bb165eb2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Eastgate Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "459 Cincinnati-Batavia Pike, Cincinnati, OH 45244, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-a2bd-770c-adc7-bd821b9d23fe.webp",
      "poi_featured_image_media": {
        "alt_text": "Animal hospital building exterior with signage and parked cars.",
        "public_id": "019d63c5-a2bd-770c-adc7-bd821b9d23fe",
        "storage_key": "property/6767906449167373/019d63c5-a2bd-770c-adc7-bd821b9d23fe.webp",
        "width": 1640,
        "height": 924
      },
      "poi_business_url": "https://eastgateanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14570249238322417836&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eastgate-animal-hospital",
      "poi_latitude": "39.1099171",
      "poi_longitude": "-84.3061452",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-528-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ12j5kzGqQYgRrBAdW3zsM8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ad3cf0f6-c392-42d5-a006-69bd2995b82b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Beechmont Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6400 Salem Rd, Cincinnati, OH 45230, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-b6ac-7035-88c7-a02f9b8642d7.webp",
      "poi_featured_image_media": {
        "alt_text": "French Bulldog sitting on a desk chair next to a filing cabinet.",
        "public_id": "019d63c5-b6ac-7035-88c7-a02f9b8642d7",
        "storage_key": "property/6767906449167373/019d63c5-b6ac-7035-88c7-a02f9b8642d7.webp",
        "width": 1780,
        "height": 3072
      },
      "poi_business_url": "https://www.beechmontpethospital.com/?utm_source=gmb&utm_medium=organic&y_source=1_MTE2Njg5MTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5324402049542219790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beechmont-pet-hospital",
      "poi_latitude": "39.0750178",
      "poi_longitude": "-84.38253329999999",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 513-232-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYcT9-6uQYgRDmhTRHQT5Ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_4b8e9386-f333-4353-b7f1-29c081ddbf0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Mercy Health - Anderson Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7500 State Rd, Cincinnati, OH 45255, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-c40a-775f-b5c3-e567ea56305a.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a modern hospital building with a blue tiled facade and a prominent main entrance.",
        "public_id": "019d63c5-c40a-775f-b5c3-e567ea56305a",
        "storage_key": "property/6767906449167373/019d63c5-c40a-775f-b5c3-e567ea56305a.webp",
        "width": 3072,
        "height": 2150
      },
      "poi_business_url": "https://www.mercy.com/locations/hospitals/cincinnati/mercy-health-anderson-hospital?utm_source=google&utm_medium=organic&utm_content=local_website_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=15827480871525014493&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-health---anderson-hospital",
      "poi_latitude": "39.0855319",
      "poi_longitude": "-84.3488196",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 513-624-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11d3-73ed-af58-9d78d08317c3.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d63c6-11d3-73ed-af58-9d78d08317c3",
        "storage_key": "property/6767906449167373/019d63c6-11d3-73ed-af58-9d78d08317c3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrb-LA0ypQYgR3duJvP6Bpts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_691fd794-9bbb-4b55-a777-9a5446fdffe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "The Christ Hospital Outpatient Center - Anderson",
      "poi_type": "Health and Wellness",
      "poi_address": "7545 Beechmont Ave Suites A-X, Cincinnati, OH 45255, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.thechristhospital.com/locations/outpatient-centers/anderson",
      "poi_directions_map_url": "https://maps.google.com/?cid=16904032683809135631&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-christ-hospital-outpatient-center---anderson",
      "poi_latitude": "39.0718859",
      "poi_longitude": "-84.3485359",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 513-564-3840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11d3-73ed-af58-9d78d08317c3.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d63c6-11d3-73ed-af58-9d78d08317c3",
        "storage_key": "property/6767906449167373/019d63c6-11d3-73ed-af58-9d78d08317c3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeNbVyypQYgRD1wJHiowl-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_810a776d-5761-4f18-93f6-ae5675779e65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Cincinnati Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4949 Tealtown Rd, Milford, OH 45150, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this nature preserve offers beautiful trails, great spaces for kids, and excellent birding opportunities. They highlight the variety of trails, the well-maintained facilities, and the peaceful, serene atmosphere. They also like the friendly staff and the many events for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-c38e-7120-b67e-8e7da79d5c95.webp",
      "poi_featured_image_media": {
        "alt_text": "Path through a lush green forest with trees and foliage.",
        "public_id": "019d63c5-c38e-7120-b67e-8e7da79d5c95",
        "storage_key": "property/6767906449167373/019d63c5-c38e-7120-b67e-8e7da79d5c95.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.cincynature.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1688270722564007801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cincinnati-nature-center",
      "poi_latitude": "39.12650319999999",
      "poi_longitude": "-84.2456414",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 513-831-1711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11c2-718b-ba1b-623826c17453.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a Christmas tree",
        "public_id": "019d63c6-11c2-718b-ba1b-623826c17453",
        "storage_key": "property/6767906449167373/019d63c6-11c2-718b-ba1b-623826c17453.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw880ByD8QIgReace_0bxbRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_d67c8e1c-cdb2-4ade-a52e-f38ee4c6e20c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3969 Round Bottom Rd, Cincinnati, OH 45244, USA",
      "poi_short_description": "Turf, sand and grass surfaced sporting grounds include baseball and soccer fields, plus playgrounds.",
      "poi_long_description": "Visitors say this park has well-maintained soccer fields with artificial turf, plenty of parking, and clean bathrooms. They also highlight the family-friendly atmosphere and the convenient location for outdoor sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-e5a5-745d-aecf-b0f060567d46.webp",
      "poi_featured_image_media": {
        "alt_text": "People playing on a turf field with goalposts and stadium lights.",
        "public_id": "019d63c5-e5a5-745d-aecf-b0f060567d46",
        "storage_key": "property/6767906449167373/019d63c5-e5a5-745d-aecf-b0f060567d46.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://andersonparks.com/riverside-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5103987625754777865&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverside-park",
      "poi_latitude": "39.1344657",
      "poi_longitude": "-84.33773579999999",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 513-474-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11c2-718b-ba1b-623826c17453.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a Christmas tree",
        "public_id": "019d63c6-11c2-718b-ba1b-623826c17453",
        "storage_key": "property/6767906449167373/019d63c6-11c2-718b-ba1b-623826c17453.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0MF0JurQYgRCVkaG7QB1UY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e07e6793-fff3-4627-815f-f36a8ccff47c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "The Golf Club at Stonelick Hills",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3155 Sherilyn Ln, Batavia, OH 45103, USA",
      "poi_short_description": "Beautiful golf course featuring 18 holes as well as a pro shop and driving range.",
      "poi_long_description": "People say this golf course offers a challenging layout with water features and risk-reward options. They highlight the beautiful scenery, the well-maintained greens, and the free practice range. They also like the friendly staff and the welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-e733-7466-b9d6-da422fbeaba2.webp",
      "poi_featured_image_media": {
        "alt_text": "Golf course with a pond and trees",
        "public_id": "019d63c5-e733-7466-b9d6-da422fbeaba2",
        "storage_key": "property/6767906449167373/019d63c5-e733-7466-b9d6-da422fbeaba2.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.stonelickhills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5820888740816503514&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-golf-club-at-stonelick-hills",
      "poi_latitude": "39.1225",
      "poi_longitude": "-84.1725",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 513-735-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1185-747c-ab9d-4ac3666408b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Stick figure kicking a ball icon",
        "public_id": "019d63c6-1185-747c-ab9d-4ac3666408b7",
        "storage_key": "property/6767906449167373/019d63c6-1185-747c-ab9d-4ac3666408b7.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdAg09wDQYgR2kJwKXjzx1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_3df6f01e-5115-4482-84af-8a357efa229f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Woodland Mound",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8250 Old Kellogg Rd, Cincinnati, OH 45255, USA",
      "poi_short_description": "1,066-acre landscape with Ohio River Valley views, offering disc golf, a wet playground & boat ramp.",
      "poi_long_description": "People say this park offers a variety of activities, including disc golf, hiking trails, a water park, and playgrounds. They highlight the clean and well-maintained facilities, and the beautiful views. They also like the peaceful and relaxing vibe. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-c581-72a0-a117-9113f3fe6a6c.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic view of rolling green hills and a distant river.",
        "public_id": "019d63c5-c581-72a0-a117-9113f3fe6a6c",
        "storage_key": "property/6767906449167373/019d63c5-c581-72a0-a117-9113f3fe6a6c.webp",
        "width": 764,
        "height": 284
      },
      "poi_business_url": "http://greatparks.org/parks/woodland-mound",
      "poi_directions_map_url": "https://maps.google.com/?cid=3195595967829453992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-mound",
      "poi_latitude": "39.0375134",
      "poi_longitude": "-84.32463279999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 513-521-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-11c2-718b-ba1b-623826c17453.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a Christmas tree",
        "public_id": "019d63c6-11c2-718b-ba1b-623826c17453",
        "storage_key": "property/6767906449167373/019d63c6-11c2-718b-ba1b-623826c17453.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVKw4vqoQYgRqCwlDJoJWSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b63bcae5-f857-4d2e-a43a-81335276e1ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Legendary Run Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "915 E Legendary Run, Cincinnati, OH 45245, USA",
      "poi_short_description": "Scenic public golf course featuring holes inspired by famous courses around the world.",
      "poi_long_description": "People say this golf course offers a challenging layout with a links-style front nine and a more wooded back nine. They also highlight the greens roll true and the bunkers play nicely.\n\nOther reviews mention the pace of play can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d1c0-77f1-b649-10be7526e415.webp",
      "poi_featured_image_media": {
        "alt_text": "Elegant clubhouse building with a white cupola and gray roof, set against a cloudy blue sky.",
        "public_id": "019d63c5-d1c0-77f1-b649-10be7526e415",
        "storage_key": "property/6767906449167373/019d63c5-d1c0-77f1-b649-10be7526e415.webp",
        "width": 1000,
        "height": 737
      },
      "poi_business_url": "http://legendaryrungolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11181548723839479027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legendary-run-golf-course",
      "poi_latitude": "39.0311738",
      "poi_longitude": "-84.2710627",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 513-753-1919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1185-747c-ab9d-4ac3666408b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Stick figure kicking a ball icon",
        "public_id": "019d63c6-1185-747c-ab9d-4ac3666408b7",
        "storage_key": "property/6767906449167373/019d63c6-1185-747c-ab9d-4ac3666408b7.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJj76PY_QHQYgR86wsa1LXLJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_97e1d5f9-d7ea-409b-a4d3-3d7571173eb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Clermont County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2001 Sporty's Dr, Batavia, OH 45103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-d66e-760f-9bd5-590f3d81887d.webp",
      "poi_featured_image_media": {
        "alt_text": "Small airplane on a runway behind a chain-link fence.",
        "public_id": "019d63c5-d66e-760f-9bd5-590f3d81887d",
        "storage_key": "property/6767906449167373/019d63c5-d66e-760f-9bd5-590f3d81887d.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://flyeca.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15730729010795328830&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clermont-county-airport",
      "poi_latitude": "39.0773544",
      "poi_longitude": "-84.20883169999999",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 513-735-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-15c1-7647-9a7c-97d27d8f6d00.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d63c6-15c1-7647-9a7c-97d27d8f6d00",
        "storage_key": "property/6767906449167373/019d63c6-15c1-7647-9a7c-97d27d8f6d00.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJbRyPTcEGQYgRPjVjurDGTto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ad4d460a-0e53-4eaa-b5dd-d3376d6fe2ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Jeff Wyler Automotive Family",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 Milford Pkwy A, Milford, OH 45150, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-e60e-722a-baaf-ffb9dbbe5d71.webp",
      "poi_featured_image_media": {
        "alt_text": "Building entrance with large logo.",
        "public_id": "019d63c5-e60e-722a-baaf-ffb9dbbe5d71",
        "storage_key": "property/6767906449167373/019d63c5-e60e-722a-baaf-ffb9dbbe5d71.webp",
        "width": 2048,
        "height": 1238
      },
      "poi_business_url": "https://wyler.com/?utm_source=google&utm_medium=organic&utm_campaign=googlemybusiness",
      "poi_directions_map_url": "https://maps.google.com/?cid=9914122984960718934&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jeff-wyler-automotive-family",
      "poi_latitude": "39.16814420000001",
      "poi_longitude": "-84.27680959999999",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 513-752-7450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWqaBaWqQYgRVnge2lMKlok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e2ed925a-6a3d-4edd-ab80-4d3d287015cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Murrplastik Systems, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1175 US-50, Milford, OH 45150, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.murrplastik.com/en/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4396445640561852879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "murrplastik-systems-inc",
      "poi_latitude": "39.144277",
      "poi_longitude": "-84.24387",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-201-3069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-_RwwwOhxokRzwEBSARQAz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bfdcf2bc-2044-4fc2-a5ad-8eb9a04fffac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Newtown Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3536 Church St, Cincinnati, OH 45244, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-faa9-757a-a36a-b9d1991e726c.webp",
      "poi_featured_image_media": {
        "alt_text": "Newtown Police car with lights on.",
        "public_id": "019d63c5-faa9-757a-a36a-b9d1991e726c",
        "storage_key": "property/6767906449167373/019d63c5-faa9-757a-a36a-b9d1991e726c.webp",
        "width": 2417,
        "height": 1368
      },
      "poi_business_url": "https://newtownohio.gov/police/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3292044638972197973&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newtown-police-department",
      "poi_latitude": "39.1255681",
      "poi_longitude": "-84.3609123",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-561-7697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-170e-7499-b022-f245c84058c6.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d63c6-170e-7499-b022-f245c84058c6",
        "storage_key": "property/6767906449167373/019d63c6-170e-7499-b022-f245c84058c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWSws3GsQYgRVbyqOiixry0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_93fed1b9-e1d6-4e63-845b-48b747b75f6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "poi_name": "Wings and Rings Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4600 Beechwood Rd Ste 800, Cincinnati, OH 45244, USA",
      "poi_short_description": "Modern sports bar with a wide range of wing flavors, plus other pub eats & kids' deals.",
      "poi_long_description": "Modern sports bar with a wide range of wing flavors, plus other pub eats & kids' deals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c5-fb20-77f0-8cca-8492868572d4.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern lounge area with comfortable seating, a high-top bar with stools, and a wall-mounted TV.",
        "public_id": "019d63c5-fb20-77f0-8cca-8492868572d4",
        "storage_key": "property/6767906449167373/019d63c5-fb20-77f0-8cca-8492868572d4.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.wingsandrings.com/?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9697927536702272278&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wings-and-rings-corporate",
      "poi_latitude": "39.1116204",
      "poi_longitude": "-84.30442",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-831-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019d63c6-1161-7750-a261-359bab4939b7",
        "storage_key": "property/6767906449167373/019d63c6-1161-7750-a261-359bab4939b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ6evECSqQYgRFjOeerb1lYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b48f345c-7d9e-40e8-9c28-e869a18b5418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a35acaa1-7e5e-45af-96da-8277dcfa3eb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e74ee695-5c45-40e2-86ea-a29db2a60b96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9fd161f7-8fa2-4d41-9ab4-955eacedb63a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_64658d88-0db1-4e8f-a5a8-52aa4551620d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f6b21c40-bfc6-4378-b28f-86224c3d9c85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_b1ac5d89-b604-4f6d-8810-366b6eda3ac3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "rating": "5.0",
      "name": "Tami Rodriguez",
      "text": "My husband, daughter, and I have lived at The Union for a little over a year. We were sold on The Union from our first meeting with Skylar. She is one of the kindest people you will meet. We have enjoyed living here. I would also say that Anthony and Quincy are incredible. They have fixed all are maintenance requests quickly and are two wonderful people.\n\nMy only complaint would be some of the pet owners not picking up after their dogs.",
      "date": "2025-07-13",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8bf7717b-f75b-4891-9c8d-6bc24c804696",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "The Union",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://360panosapv.s3.us-east-2.amazonaws.com/TheUnionAtEastgate/index.htm"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1ddc-9e22-7538-b1cd-6a4db4967d56",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "tum---the-union",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373"
    },
    {
      "lead_collector_id": "019e1ddc-9e91-734a-af22-f1cac11ef2a8",
      "lead_source": "FACEBOOK_ADS",
      "name": "tum---the-union",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373"
    },
    {
      "lead_collector_id": "019e1ddc-9f08-732f-826c-07adbeb733a8",
      "lead_source": "LANDING_PAGE",
      "name": "tum---the-union",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "luxury-apartments-heated-saltwater-pool-cincinnati-oh",
      "search_query": "luxury apartments with heated saltwater pool Cincinnati OH",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Heated Saltwater Pool",
      "h2_subtitle": "Discover luxury living in Cincinnati, OH with our heated saltwater pool. Experience unparalleled amenities at The Union at Eastgate.",
      "page_copy": "Experience the height of luxury living at The Union at Eastgate, where our apartments redefine modern convenience. Located in the vibrant Outer Clermont County, our stylish studio, one, and two-bedroom homes offer energy-efficient kitchens and expansive walk-in closets. But what truly sets us apart is our luxury heated saltwater pool—a perfect retreat after a bustling day in downtown Cincinnati.\n\nBeyond the pool, we cater to varied lifestyles with an impressive range of amenities. Socialize in our sports entertainment lounge or unwind at the outdoor fire pit lounges. Busy professionals will appreciate our co-working spaces, while pet owners will love the convenient pet spa. Nestled in Cincinnati, OH, The Union at Eastgate is more than just a place to live—it's a lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Saltwater Pool",
      "seo_description": "Discover luxury living at The Union at Eastgate, Cincinnati, with a heated saltwater pool and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-pet-spa-clermont-county",
      "search_query": "pet friendly apartments with pet spa Clermont County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Pet Spa",
      "h2_subtitle": "Explore pet-friendly living in Clermont County with our pet spa. The Union at Eastgate offers a welcoming home for you and your furry friends.",
      "page_copy": "Welcome to The Union at Eastgate, where pet-friendly apartment living is redefined in Clermont County. Our residences offer exceptional features like energy-efficient kitchens and walk-in closets, providing comfort for you and your furry companions. Your pets will enjoy our on-site pet spa, designed to cater to their grooming needs and ensure they feel pampered.\n\nSituated in the charming Outer Clermont County, our community fosters a vibrant lifestyle with a wealth of amenities. Residents can relax at the luxury heated saltwater pool or gather with friends in our outdoor fire pit lounges. Our pet-friendly environment ensures that every member of your household, including the four-legged ones, feels right at home. Experience the perfect blend of style, convenience, and pet-friendly living at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Pet Spa",
      "seo_description": "Find pet-friendly apartments in Clermont County at The Union at Eastgate, featuring a dedicated pet spa for your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-near-i71-cincinnati",
      "search_query": "in-unit laundry apartments near I-71 Cincinnati",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Near I-71",
      "h2_subtitle": "Looking for convenience? Discover apartments with in-unit laundry near I-71 in Cincinnati for a hassle-free lifestyle at The Union at Eastgate.",
      "page_copy": "At The Union at Eastgate, enjoy the convenience of in-unit laundry in our stylish apartments near I-71, Cincinnati. Our studio, one, and two-bedroom homes come equipped with washers and dryers, allowing you to manage your laundry with ease and comfort. Located just minutes from bustling downtown Cincinnati, our community provides easy access to the area's major highways, including I-71.\n\nBeyond laundry conveniences, The Union at Eastgate offers a host of amenities designed to enhance your living experience. From our luxury heated saltwater pool to the sports entertainment lounge and outdoor fire pit lounges, there's plenty here to enjoy. Whether you're commuting or relaxing at home, our apartments offer everything you need for a seamless lifestyle right in the heart of Clermont County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Near I-71",
      "seo_description": "Find apartments in Cincinnati near I-71 with in-unit laundry at The Union at Eastgate, offering modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "modern-apartments-air-conditioning-clermont-county",
      "search_query": "modern apartments with air conditioning in Outer Clermont County",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Air Conditioning",
      "h2_subtitle": "Stay comfortable in Outer Clermont County with our modern apartments featuring air conditioning. Experience elevated living at The Union at Eastgate.",
      "page_copy": "Discover contemporary living at The Union at Eastgate, offering modern apartments equipped with air conditioning in Outer Clermont County. Our thoughtfully designed studio, one, and two-bedroom homes provide a refreshing retreat from the hustle and bustle of Cincinnati. Each unit is crafted for comfort and efficiency, featuring not only air conditioning but also energy-efficient kitchens and spacious walk-in closets.\n\nIn addition to comfortable interiors, residents enjoy a wealth of amenities that enhance daily living. Relax by our luxury heated saltwater pool, unwind in the sports entertainment lounge, or gather around our outdoor fire pit lounges. Nestled in a serene location, yet just minutes from the vibrant life of downtown Cincinnati, The Union at Eastgate is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Air Conditioning",
      "seo_description": "Find modern apartments with air conditioning in Outer Clermont County at The Union at Eastgate, offering comfort and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-business-center-coworking-space-cincinnati",
      "search_query": "apartments with business center and co-working space Cincinnati",
      "category": "Amenity",
      "h1_title": "Apartments with Business Center in Cincinnati",
      "h2_subtitle": "Find your professional hub at The Union at Eastgate. Enjoy apartments with a business center and co-working space right in Cincinnati.",
      "page_copy": "Imagine working from the comfort of your home without sacrificing productivity. At The Union at Eastgate in Cincinnati, our apartments come equipped with a dedicated business center and co-working space, making it easy for you to focus on your work right within the community. Perfect for remote workers and entrepreneurs, this feature highlights The Union at Eastgate as an ideal home base.\n\nLocated in the vibrant area of Outer Clermont County, just minutes from downtown Cincinnati, our community blends convenience with luxury. Residents have access to outstanding amenities like a luxury heated saltwater pool and sports entertainment lounge. Enjoy the ease of modern living with seamless access to all the resources you need at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Business Center in Cincinnati",
      "seo_description": "Discover Cincinnati apartments with a business center and co-working space at The Union at Eastgate, designed for modern living and work.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "studio-apartments-cincinnati-oh",
      "search_query": "studio apartments cincinnati oh",
      "category": "Floorplan",
      "h1_title": "Stylish Studio Apartments in Cincinnati, OH",
      "h2_subtitle": "Explore modern studio apartments in Cincinnati, OH at The Union at Eastgate. Enjoy upscale living with premium amenities.",
      "page_copy": "Discover the ultimate in modern living with our stylish studio apartments in Cincinnati, OH at The Union at Eastgate. Each studio is thoughtfully designed for comfort and functionality, featuring walk-in closets and energy-efficient kitchens. Located in the peaceful area of Outer Clermont County, our community offers the perfect blend of convenience and tranquility.\n\nAlongside your sleek living space, indulge in top-tier amenities such as a luxury heated saltwater pool, sophisticated sports entertainment lounge, and convenient outdoor fire pit lounges. With easy access to downtown Cincinnati and major highways, The Union at Eastgate is ideal for those seeking a vibrant and connected lifestyle in a serene setting. Make the move today and experience unparalleled living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stylish Studio Apartments in Cincinnati, OH",
      "seo_description": "Find modern studio apartments in Cincinnati, OH at The Union at Eastgate, offering premium amenities and convenient access to the city.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-clermont-county",
      "search_query": "1 bedroom apartments clermont county",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Clermont County",
      "h2_subtitle": "Discover charming 1 bedroom apartments in Clermont County. The Union at Eastgate offers modern amenities and a great location.",
      "page_copy": "Welcome to The Union at Eastgate, where living meets luxury in our stunning 1 bedroom apartments in Clermont County. Each residence offers a perfect blend of style and functionality with energy-efficient kitchens, spacious walk-in closets, and in-unit washers and dryers, providing an ideal base for residents seeking comfort and elegance.\n\nNestled in Outer Clermont County, our community features premium amenities designed to elevate your lifestyle. Relax in the luxury heated saltwater pool, engage with friends in the sports entertainment lounge, or enjoy a tranquil evening at our outdoor fire pit lounges. Just minutes from downtown Cincinnati, The Union at Eastgate combines accessibility with a serene environment, making it the perfect choice for modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Clermont County",
      "seo_description": "Explore 1 bedroom apartments in Clermont County at The Union at Eastgate, offering modern amenities and easy access to Cincinnati.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-near-45245",
      "search_query": "2 bedroom apartments near 45245",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 45245",
      "h2_subtitle": "Explore spacious 2 bedroom apartments near 45245. The Union at Eastgate offers modern living with excellent amenities.",
      "page_copy": "Discover the perfect living space at The Union at Eastgate, offering spacious 2 bedroom apartments near 45245. Designed with comfort and style in mind, these residences feature energy-efficient kitchens, ample walk-in closets, and modern in-unit washers and dryers, ensuring every convenience is at your fingertips.\n\nLocated in the welcoming Outer Clermont County, our community provides not just a home but a lifestyle, with access to superior amenities such as a luxury heated saltwater pool and lively sports entertainment lounge. Enjoy the best of both worlds with serene living close to downtown Cincinnati, making The Union at Eastgate an ideal destination for those seeking a vibrant and convenient lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 45245",
      "seo_description": "Find spacious 2 bedroom apartments near 45245 at The Union at Eastgate, offering luxurious amenities and convenient access to Cincinnati.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-near-clough-pike-elementary-cincinnati",
      "search_query": "apartments near clough pike elementary cincinnati",
      "category": "School",
      "h1_title": "Apartments Near Clough Pike Elementary Cincinnati",
      "h2_subtitle": "Find your new home with apartments near Clough Pike Elementary Cincinnati. The Union at Eastgate offers convenient living and top amenities.",
      "page_copy": "Looking for a place to call home? The Union at Eastgate offers premium apartments near Clough Pike Elementary Cincinnati, perfect for parents seeking proximity to quality education. Our community features modern studio, one, and two-bedroom apartments equipped with energy-efficient kitchens, providing a comfortable environment for families of all sizes.\n\nNestled in the scenic Outer Clermont County, just minutes from Cincinnati's vibrant downtown, our apartments come with exclusive access to exceptional amenities including a heated saltwater pool and lively sports entertainment lounge. Enjoy unmatched convenience and a welcoming neighborhood atmosphere, making the transition smooth for you and your family.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clough Pike Elementary Cincinnati",
      "seo_description": "Discover apartments near Clough Pike Elementary Cincinnati at The Union at Eastgate, offering modern units and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "rental-units-around-west-clermont-middle-school-oh",
      "search_query": "rental units around west clermont middle school oh",
      "category": "School",
      "h1_title": "Rental Units Near West Clermont Middle School",
      "h2_subtitle": "Explore quality rental units around West Clermont Middle School OH. The Union at Eastgate provides modern living with superb amenities.",
      "page_copy": "Searching for the ideal spot for your family? Consider The Union at Eastgate, offering appealing rental units around West Clermont Middle School OH. Our community features stylish studio, one, and two-bedroom apartments equipped with energy-efficient kitchens and ample walk-in closets, perfect for families seeking comfort and modern conveniences.\n\nLocated in the inviting Outer Clermont County, minutes away from Cincinnati, you will enjoy the luxury of a community that offers a heated saltwater pool, sports entertainment lounge, and more. With easy access to downtown and a peaceful environment near top schools, The Union at Eastgate provides a harmonious blend of convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Units Near West Clermont Middle School",
      "seo_description": "Find modern rental units near West Clermont Middle School OH at The Union at Eastgate, featuring great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "living-spaces-by-west-clermont-high-school-clermont-county",
      "search_query": "living spaces by west clermont high school clermont county",
      "category": "School",
      "h1_title": "Living Spaces by West Clermont High School",
      "h2_subtitle": "Discover premium living spaces by West Clermont High School in Clermont County. The Union at Eastgate offers luxury and convenience.",
      "page_copy": "For those seeking exceptional living spaces by West Clermont High School in Clermont County, The Union at Eastgate is the perfect choice. Our modern apartments offer everything you need for comfortable and convenient living, from stylish studio, one, and two-bedroom layouts to energy-efficient kitchens and spacious walk-in closets.\n\nLocated within reach of Cincinnati's lively downtown yet nestled in the serene Outer Clermont County, the Union at Eastgate provides residents with top-notch amenities, including a heated saltwater pool, a pet spa, and co-working spaces. Experience the perfect blend of tranquility and modern conveniences just moments away from excellent educational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Spaces by West Clermont High School",
      "seo_description": "Find luxurious living spaces by West Clermont High School in Clermont County at The Union at Eastgate, with excellent amenities and location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartment-homes-next-to-merwin-elementary-cincinnati",
      "search_query": "apartment homes next to merwin elementary cincinnati",
      "category": "School",
      "h1_title": "Apartment Homes Next to Merwin Elementary",
      "h2_subtitle": "Explore excellent apartment homes next to Merwin Elementary Cincinnati. The Union at Eastgate offers modern amenities and convenience.",
      "page_copy": "If you're on the hunt for apartment homes next to Merwin Elementary in Cincinnati, The Union at Eastgate presents an ideal living solution. Our community provides stylish studio, one, and two-bedroom apartments, boasting energy-efficient kitchens and generous walk-in closets, perfect for families and individuals alike.\n\nSituated in the beautiful Outer Clermont County, just minutes from the bustling heart of Cincinnati, our property offers exclusive access to enticing amenities such as a heated saltwater pool, an outdoor fire pit lounge, and a welcoming pet spa. Discover a harmonious lifestyle where top educational facilities and modern living come together seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Next to Merwin Elementary",
      "seo_description": "Discover modern apartment homes next to Merwin Elementary Cincinnati at The Union at Eastgate, offering excellent amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "residences-by-withamsville-tobasco-elem-school",
      "search_query": "residences by withamsville-tobasco elem school outer clermont county",
      "category": "School",
      "h1_title": "Residences by Withamsville-Tobasco Elementary",
      "h2_subtitle": "Find premium residences by Withamsville-Tobasco Elem School in Outer Clermont County. Enjoy modern amenities at The Union at Eastgate.",
      "page_copy": "Looking for exceptional residences by Withamsville-Tobasco Elementary School in Outer Clermont County? The Union at Eastgate offers the perfect place to call home, featuring contemporary studio, one, and two-bedroom apartments complete with energy-efficient kitchens and spacious walk-in closets.\n\nLocated in the serene Outer Clermont County, our community provides a peaceful retreat with easy access to Cincinnati. Enjoy an array of luxurious amenities, such as a heated saltwater pool, co-working spaces, and a sports entertainment lounge. Experience the balance of top-tier education facilities and a vibrant community atmosphere all at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences by Withamsville-Tobasco Elementary",
      "seo_description": "Explore modern residences by Withamsville-Tobasco Elem School in Outer Clermont County at The Union at Eastgate, offering luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "units-close-to-summerside-elementary-45245",
      "search_query": "units close to summerside elementary zip 45245",
      "category": "School",
      "h1_title": "Units Close to Summerside Elementary",
      "h2_subtitle": "Explore units close to Summerside Elementary in zip 45245. The Union at Eastgate provides comfort and style with modern amenities.",
      "page_copy": "Located in the convenient zip code of 45245, The Union at Eastgate offers exceptional units close to Summerside Elementary, perfect for families and individuals who value both education and lifestyle. Our community features a variety of studio, one, and two-bedroom apartments designed with energy-efficient kitchens and ample walk-in closets.\n\nNestled in the inviting Outer Clermont County area yet minutes from the heart of Cincinnati, residents can enjoy luxurious amenities like a heated saltwater pool, a relaxing outdoor fire pit lounge, and modern co-working spaces. Embrace a living experience that seamlessly merges quality education with everyday convenience at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Units Close to Summerside Elementary 45245",
      "seo_description": "Find modern units close to Summerside Elementary in zip 45245 at The Union at Eastgate, featuring luxurious amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartment-complexes-near-willowville-elementary-oh",
      "search_query": "apartment complexes near willowville elementary oh",
      "category": "School",
      "h1_title": "Apartment Complexes Near Willowville Elementary",
      "h2_subtitle": "Discover stunning apartment complexes near Willowville Elementary, OH. The Union at Eastgate offers exceptional amenities and modern living.",
      "page_copy": "For those searching for apartment complexes near Willowville Elementary in OH, The Union at Eastgate presents a distinguished choice. Our community offers stylish studio, one, and two-bedroom apartments equipped with energy-efficient kitchens and spacious walk-in closets, ideal for modern lifestyles.\n\nLocated in Outer Clermont County, just a short drive from Cincinnati, residents of The Union at Eastgate enjoy exceptional amenities like a luxurious heated saltwater pool, a pet-friendly environment, and convenient co-working spaces. Experience a perfect blend of education proximity and high-quality living at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Complexes Near Willowville Elementary OH",
      "seo_description": "Explore apartment complexes near Willowville Elementary, OH at The Union at Eastgate, offering modern living and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "rentals-by-child-focus-early-learning-cincinnati",
      "search_query": "rentals by child focus early learning cincinnati",
      "category": "School",
      "h1_title": "Rentals by Child Focus Early Learning",
      "h2_subtitle": "Discover rentals by Child Focus Early Learning in Cincinnati. Enjoy modern living with premium amenities at The Union at Eastgate.",
      "page_copy": "Searching for rentals by Child Focus Early Learning in Cincinnati? The Union at Eastgate offers the perfect match with contemporary studio, one, and two-bedroom units designed for both convenience and style. Every apartment features energy-efficient kitchens and spacious walk-in closets, designed for comfortable modern living.\n\nLocated in the peaceful Outer Clermont County, our community stands out with luxurious amenities such as a heated saltwater pool, exclusive co-working spaces, and a welcoming pet spa—all just a short drive from Cincinnati’s vibrant downtown. Choose The Union at Eastgate for a harmonious blend of education access and elevated living experiences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Child Focus Early Learning Cincinnati",
      "seo_description": "Find rentals by Child Focus Early Learning Cincinnati at The Union at Eastgate, where modern amenities meet stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-close-to-uc-clermont-college",
      "search_query": "apartments close to uc clermont college outer clermont county",
      "category": "School",
      "h1_title": "Apartments Close to UC Clermont College",
      "h2_subtitle": "Explore apartments close to UC Clermont College in Outer Clermont County. Enjoy premium amenities and modern design at The Union at Eastgate.",
      "page_copy": "Located in Outer Clermont County, The Union at Eastgate offers an ideal living solution for those seeking apartments close to UC Clermont College. Our community features elegantly designed studio, one, and two-bedroom apartments, perfect for students and professionals alike, equipped with energy-efficient kitchens and expansive walk-in closets.\n\nJust minutes from the educational hub of UC Clermont, residents benefit from a relaxing community atmosphere complemented by premium amenities, including a heated saltwater pool, outdoor fire pit lounges, and co-working spaces. Experience a seamless blend of academic proximity and leisure living at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to UC Clermont College",
      "seo_description": "Find stylish apartments close to UC Clermont College in Outer Clermont County with top amenities at The Union at Eastgate.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-near-cincinnati-childrens-eastgate",
      "search_query": "apartments near cincinnati children's eastgate clermont county",
      "category": "Hospital",
      "h1_title": "Apartments Near Cincinnati Children's Eastgate",
      "h2_subtitle": "Discover comfortable apartments near Cincinnati Children's Eastgate in Clermont County. Enjoy modern design and amenities at The Union at Eastgate.",
      "page_copy": "If you're seeking apartments near Cincinnati Children's Eastgate in Clermont County, The Union at Eastgate offers a perfect living option. Our community features stylish studio, one, and two-bedroom apartments that are thoughtfully designed with energy-efficient kitchens and walk-in closets, ideal for both families and professionals.\n\nSituated just a short drive from Cincinnati Children’s Eastgate, our residents enjoy unparalleled community benefits such as a luxury heated saltwater pool, pet spa, and vibrant co-working spaces. Experience the convenience and comfort of living near top-notch healthcare facilities with the added benefit of luxurious community life at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cincinnati Children's Eastgate",
      "seo_description": "Explore modern apartments near Cincinnati Children's Eastgate in Clermont County with top-tier amenities at The Union at Eastgate.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-near-ivy-pointe-park-clermont-county",
      "search_query": "apartments near Ivy Pointe Park Clermont County",
      "category": "Park",
      "h1_title": "Apartments Near Ivy Pointe Park",
      "h2_subtitle": "Find apartments near Ivy Pointe Park in Clermont County. Discover modern living with exceptional amenities at The Union at Eastgate.",
      "page_copy": "For those searching for apartments near Ivy Pointe Park in Clermont County, The Union at Eastgate offers an exceptional living experience. Our community provides elegantly designed studio, one, and two-bedroom apartments, each equipped with energy-efficient kitchens and ample walk-in closets, promising both style and functionality.\n\nNestled conveniently close to Ivy Pointe Park, residents of The Union at Eastgate enjoy access to outstanding amenities such as a heated saltwater pool, sports entertainment lounge, and pet spa. Experience the perfect blend of outdoor adventure and luxurious home comforts by choosing The Union at Eastgate as your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ivy Pointe Park",
      "seo_description": "Discover stylish apartments near Ivy Pointe Park in Clermont County with luxurious amenities at The Union at Eastgate.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "rental-homes-close-to-veterans-memorial-park",
      "search_query": "rental homes close to Veterans Memorial Park Cincinnati",
      "category": "Park",
      "h1_title": "Rental Homes Near Veterans Memorial Park",
      "h2_subtitle": "Explore rental homes close to Veterans Memorial Park in Cincinnati. Experience modern living with thoughtful amenities at The Union at Eastgate.",
      "page_copy": "For those looking for rental homes close to Veterans Memorial Park in Cincinnati, The Union at Eastgate offers an ideal living option. Our community features studio, one, and two-bedroom apartments, each designed with modern conveniences like energy-efficient kitchens and spacious walk-in closets, providing the perfect balance of comfort and style.\n\nLocated conveniently near Veterans Memorial Park, residents can enjoy a host of amenities including a luxury heated saltwater pool, outdoor fire pit lounges, and a sports entertainment lounge. Embrace the charm of park-side living with the contemporary comforts offered at The Union at Eastgate, where community and lifestyle blend seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Veterans Memorial Park",
      "seo_description": "Find modern rental homes close to Veterans Memorial Park in Cincinnati with luxurious community amenities at The Union at Eastgate.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-by-clepper-park-oh",
      "search_query": "apartments by Clepper Park OH",
      "category": "Park",
      "h1_title": "Apartments by Clepper Park OH",
      "h2_subtitle": "Discover apartments by Clepper Park, OH. Enjoy the convenience of proximity and luxury amenities at The Union at Eastgate.",
      "page_copy": "If you're searching for apartments by Clepper Park, OH, The Union at Eastgate offers an outstanding living experience. Our well-appointed studio, one, and two-bedroom apartments come with energy-efficient kitchens and sizable walk-in closets, providing both style and utility for modern renters.\n\nJust minutes from Clepper Park, residents can enjoy a dynamic community experience with amenities such as a heated saltwater pool, pet spa, and outdoor lounges with fire pits. Embrace the tranquility of park-side living combined with the comfort and luxury provided by The Union at Eastgate, the perfect residence for those who value both leisure and practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Clepper Park OH",
      "seo_description": "Explore luxury apartments by Clepper Park, OH, offering convenience and top amenities at The Union at Eastgate.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "living-near-mt-carmel-park-ohio",
      "search_query": "living near Mt. Carmel Park Ohio",
      "category": "Park",
      "h1_title": "Living Near Mt. Carmel Park Ohio",
      "h2_subtitle": "Experience living near Mt. Carmel Park, Ohio with modern amenities at The Union at Eastgate, providing a sophisticated lifestyle.",
      "page_copy": "For those considering living near Mt. Carmel Park, Ohio, The Union at Eastgate presents the perfect community filled with modern conveniences. Our community houses stylish studio, one, and two-bedroom apartments, each equipped with energy-efficient kitchens and spacious walk-in closets, designed with contemporary living in mind.\n\nLocated just a short distance from Mt. Carmel Park, residents enjoy easy access to both nature and upscale amenities, including a luxury heated saltwater pool, sports entertainment lounge, and co-working spaces. The Union at Eastgate allows you to enjoy a seamless blend of natural beauty and modern comfort, offering an idyllic living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Mt. Carmel Park Ohio",
      "seo_description": "Enjoy living near Mt. Carmel Park, Ohio with luxurious apartments and top-tier amenities at The Union at Eastgate.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-near-pierce-township-locust-corner-park-trails",
      "search_query": "apartments near Pierce Township Locust Corner Park & Trails Cincinnati",
      "category": "Park",
      "h1_title": "Apartments Near Locust Corner Park & Trails",
      "h2_subtitle": "Explore apartments near Pierce Township's Locust Corner Park & Trails in Cincinnati. Experience nature and luxury with The Union at Eastgate.",
      "page_copy": "Looking for apartments near Pierce Township Locust Corner Park & Trails in Cincinnati? The Union at Eastgate offers a luxurious living experience close to nature. Our community features studio, one, and two-bedroom apartments with modern amenities such as energy-efficient kitchens and spacious walk-in closets, perfectly designed for today's lifestyle seekers.\n\nReside in a vibrant community that provides easy access to Locust Corner Park & Trails, perfect for outdoor enthusiasts. Our on-site amenities include a heated saltwater pool, outdoor fire pit lounges, and a pet spa, ensuring that relaxation and convenience are just steps away from your home. Discover the ideal balance of nature and contemporary living at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Locust Corner Park & Trails",
      "seo_description": "Find luxurious living near Pierce Township Locust Corner Park & Trails in Cincinnati at The Union at Eastgate, complete with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "housing-by-otto-armleder-memorial-park-45245",
      "search_query": "housing by Otto Armleder Memorial Park 45245",
      "category": "Park",
      "h1_title": "Housing by Otto Armleder Memorial Park",
      "h2_subtitle": "Discover exceptional housing by Otto Armleder Memorial Park in the 45245 area, offering modern comforts at The Union at Eastgate.",
      "page_copy": "For those seeking housing by Otto Armleder Memorial Park in the 45245 area, The Union at Eastgate provides a premium living experience with a touch of nature. Our stylish studio, one, and two-bedroom residences are designed with sophistication, featuring energy-efficient kitchens and expansive walk-in closets to suit your needs.\n\nSituated conveniently close to Otto Armleder Memorial Park, residents can enjoy the lush surroundings of the park while also having access to top-tier amenities like a heated saltwater pool, sports entertainment lounge, and pet spa. Enjoy a blend of nature and luxury at The Union at Eastgate, an ideal locale for those who cherish both outdoor beauty and exceptional home features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing by Otto Armleder Memorial Park",
      "seo_description": "Explore housing options at The Union at Eastgate near Otto Armleder Memorial Park in 45245, featuring modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-near-shor-park-outer-clermont-county",
      "search_query": "apartments near Shor Park Outer Clermont County",
      "category": "Park",
      "h1_title": "Apartments Near Shor Park in Clermont County",
      "h2_subtitle": "Find stunning apartments near Shor Park in Outer Clermont County. Enjoy upscale living with The Union at Eastgate.",
      "page_copy": "Searching for apartments near Shor Park in Outer Clermont County? The Union at Eastgate is your ideal destination. Our community offers sophisticated studio, one, and two-bedroom apartments equipped with modern amenities like energy-efficient kitchens and spacious walk-in closets, perfect for those seeking contemporary living.\n\nNestled close to Shor Park, residents have access to a serene natural environment, perfect for those who appreciate both outdoor activities and modern comforts. The Union at Eastgate features luxurious on-site amenities, including a heated saltwater pool and sports entertainment lounge, making it easier for residents to relax and unwind. Embrace the perfect blend of natural beauty and luxury at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Shor Park in Clermont County",
      "seo_description": "Discover upscale apartments near Shor Park in Outer Clermont County at The Union at Eastgate, offering modern living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "rental-properties-close-to-pattison-park-lodgeside",
      "search_query": "rental properties close to Pattison Park Lodgeside",
      "category": "Park",
      "h1_title": "Rental Properties Close to Pattison Park Lodgeside",
      "h2_subtitle": "Explore rental properties close to Pattison Park Lodgeside and discover modern living at The Union at Eastgate.",
      "page_copy": "Looking for rental properties close to Pattison Park Lodgeside? Discover modern living at The Union at Eastgate. Situated just a short drive from the picturesque Pattison Park, our community offers well-appointed studio, one, and two-bedroom apartments designed with energy-efficient kitchens and spacious walk-in closets to enhance your lifestyle.\n\nResidents can enjoy easy access to the natural beauty of Pattison Park while also benefiting from our exceptional amenities, such as the luxury heated saltwater pool, co-working spaces, and sports entertainment lounge. The Union at Eastgate combines the tranquility of nature with the convenience of upscale amenities, providing a well-rounded living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Properties Near Pattison Park Lodgeside",
      "seo_description": "Discover rental properties near Pattison Park Lodgeside at The Union at Eastgate, where nature meets modern luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167373",
      "source": "custom",
      "page_item_url": "apartments-near-cincinnati-northern-kentucky-airport",
      "search_query": "apartments near Cincinnati/Northern Kentucky International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Cincinnati/NKY Airport",
      "h2_subtitle": "Discover convenient apartments near Cincinnati/Northern Kentucky International Airport with luxury amenities at The Union at Eastgate.",
      "page_copy": "Searching for apartments near Cincinnati/Northern Kentucky International Airport? The Union at Eastgate offers a prime location just a short commute from the airport, providing easy access for frequent travelers or aviation enthusiasts. Our community features modern studio, one, and two-bedroom apartments that boast energy-efficient kitchens and spacious walk-in closets, designed to exceed your expectations.\n\nResidents at The Union at Eastgate enjoy not only proximity to the airport but also a wealth of amenities like a luxury heated saltwater pool, outdoor fire pit lounges, and state-of-the-art fitness center. Whether you're jet-setting or commuting, experience unparalleled convenience and comfort at The Union at Eastgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with blue umbrellas.",
        "public_id": "019d63c6-9d8d-754f-a023-dcae8642cf38",
        "storage_key": "property/6767906449167373/019d63c6-9d8d-754f-a023-dcae8642cf38.webp",
        "width": 3000,
        "height": 2247
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cincinnati/NKY Airport",
      "seo_description": "Find convenient apartments near Cincinnati/NKY Airport at The Union at Eastgate, featuring modern amenities and easy access to travel.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6271"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11680180395"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5165068"
    },
    {
      "ID": "custom_adtaxi_domain",
      "type": "STRING",
      "value": "https://tags.tiqcdn.com/utag/adtaxi/unioneastgate.com/prod/utag.js"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-55SDF87P"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "58525255282"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "94aec113911eeba2"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "c0c85c72a64e11edbd41023423a61a29"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "513-966-4249"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InJCdEdpUHptaUpUVkJ6alhNUHFRZVE9PSIsInZhbHVlIjoiTG9GQm5hSG9CeGlXVXVpdGFGdnVhQT09IiwibWFjIjoiOWIzOWQxNDE0ZWFlZjE4OGNiYzBhZGJiNzc4MDlhYjM4ZDYwNjJhMWEyNmU0MTMxNjVmYzBhYjAzZDhiNDY1MyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "6271",
  "custom_repli_id": "11680180395",
  "custom_realpage_id": "5165068",
  "custom_adtaxi_domain": "https://tags.tiqcdn.com/utag/adtaxi/unioneastgate.com/prod/utag.js",
  "custom_google_gtm_id": "GTM-55SDF87P",
  "custom_rollout_phase": "Phase 2",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "58525255282",
  "custom_knock_community_id": "94aec113911eeba2",
  "custom_knock_company_token": "c0c85c72a64e11edbd41023423a61a29",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "513-966-4249",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InJCdEdpUHptaUpUVkJ6alhNUHFRZVE9PSIsInZhbHVlIjoiTG9GQm5hSG9CeGlXVXVpdGFGdnVhQT09IiwibWFjIjoiOWIzOWQxNDE0ZWFlZjE4OGNiYzBhZGJiNzc4MDlhYjM4ZDYwNjJhMWEyNmU0MTMxNjVmYzBhYjAzZDhiNDY1MyJ9",
  "custom_audioeye_site_id": "ab1e5797-df17-4969-ad55-d30e8763e93e",
  "custom_audioeye_site_hash": "8cefcb8490a71405befa5e56550a98a6"
};

export const generatedAt = '2026-11-03T23:03:34.758Z';
